import { Component, OnInit, OnDestroy, Input} from '@angular/core';
import { Router, NavigationExtras } from '@angular/router';
import { DashboardService } from './dashboard.service';
import { ToastrService } from 'ngx-toastr';
import * as Highcharts from 'highcharts';
import HighchartsExporting from 'highcharts/modules/exporting';
import HighchartsExportData from 'highcharts/modules/export-data';
import { DatePipe, VERSION, LocationStrategy } from '@angular/common';
import { Subscription, interval, Subject, fromEvent } from 'rxjs';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import * as _moment from 'moment';
import { default as _rollupMoment } from 'moment';
import { takeUntil, filter, debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';
import { Loader, NgxUiLoaderService, SPINNER } from 'ngx-ui-loader';
import { BnNgIdleService } from 'bn-ng-idle';
import { HighchartsService } from './highchart.service'
import { yaxisDataWNSTodayGraph, yaxisDataZEUserTimeyGraph, yaxisDataZEUserTimeyGraph1, yaxisDataChartOptions15, yaxisDataChartOptions12 } from './constant'; import { DataService } from 'src/app/data-service/data.service';

// const LOGO_URL = 'https://raw.githubusercontent.com/t-ho/ngx-ui-loader/master/src/assets/angular.png';

HighchartsExporting(Highcharts);
HighchartsExportData(Highcharts);

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  providers: [DatePipe]
})
export class DashboardComponent implements OnInit, OnDestroy {
  loaders: any[];
  // totalEpcUser: any;
  // totalEpcDevices: any;
  // activeEpcDevices: any;
  // inactiveEpcDevices: any;
  // totalEpcSolarCapacity: any;
  // totalEpcEnergyGenerated: any;
  // co2EmmisionSavedEpc: any;
  normalGraphSpicificYeild: any;
  monthPowerSumNormalUser: any;
  yearPowerSumNormalUser: any;
  yearSpicificYeildNormalUser: any;
  lifeTimePowerSumNormalUser: any;
  monthDaySpcificYeildWmsUser: any;
  monthPowerSumWmsUser: any;
  LifeTimePowerSumWmsUser: any;
  YearPowerSumWmsUser: any;
  YearSpcificYeildWmsUser: any;
  dgAdminUserCount: number;
  DGUserCount: number;
  srcString: string;
  dev_status: any;
  eventtype: any;
  sub_device_id: any;
  is_emeter: any;
  is_wms: any;
  loadGrid: any;
  load: any;
  solar_power: any;
  load_power: any;
  dg_power: any;
  eng_imp: any;
  eng_imp_day: any;
  error: any;
  inv_error: any;
  inv_title: any;
  met_error: any;
  met_status: any;
  title: any;
  ename: any = "test";
  flag: boolean = true;
  loadGridObject: any;
  public subDevice_id: any;
  public serial_no: any;
  serial_noD: any;
  meterStatusD: any;
  sub_device_idD: any;
  public sub_device_id_inv: any;
  public serial_no_inv: any;
  public inverterList: any = [];
  // public spp:any=[];
  deviceRequestObject: any = {};
  invRequestObject: any = {};
  public wmsSerial_no;
  public wmsSubDevice_id;
  public wmsInverterList = [];
  // private ResponseVerifiedNormalUserInverterList: Subject<any> = new Subject();
  // private ResponsWmsUserInverterList: Subject<any> = new Subject();
  changeText: boolean;
  IrrGraphArray4: any = [];
  IrrGraphArray5: any[];
  // private searchSubject = new Subject<string>();
  private searchAdminUsersSubject = new Subject<string>();
  private destroy$ = new Subject<void>();
  // tslint:disable-next-line:max-line-length
  constructor(private bnIdle: BnNgIdleService, private ngxUiLoaderService: NgxUiLoaderService, private location: LocationStrategy, private fb: FormBuilder, private dashboardService: DashboardService, private router: Router,
    private toastr: ToastrService, private datePipe: DatePipe, private dataService: DataService, private highChartService: HighchartsService
  ) {
    this.changeText = false;


    //this.gridDate =  this.datePipe.transform(this.gridDate, 'yyyy-MM-dd');

    // history disble
    history.pushState(null, null, window.location.href);
    this.location.onPopState(() => {
      history.pushState(null, null, window.location.href);
    });

    this.role = localStorage.role;
    if (this.role === '1') {
      this.roleName = 'admin';
      this.through = 'admin';
    } else if (this.role === '2') {
      this.roleName = 'epc';
      this.through = 'epc';
    } else if (this.role === '3') {
      this.roleName = 'wms';
    } else if (this.role === '4') {
      this.roleName = 'normal';
    } else if (this.role === '5') {
      this.roleName = 'slave_admin';
      this.through = 'slave_admin';
      this.slave_admin_id = localStorage.id;
    }
    else if (this.role === '6') {
      this.roleName = 'ze';
    }
    else if (this.role === '7') {
      this.roleName = 'dg';
    }
    // For Multiple Loaders
    this.loaders = [
      {
        // hasProgressBar: true,
        loaderId: 'loader-00',
        // logoUrl: LOGO_URL,
        logoSize: 80,
        isMaster: true,
        spinnerType: SPINNER.ballScaleMultiple,
      },
      { // used

        // hasProgressBar: true,
        loaderId: 'loader-01',
        spinnerType: SPINNER.ballScaleMultiple,
      },
      { // used
        // hasProgressBar: true,
        loaderId: 'loader-02',
        // isMaster: false,
        spinnerType: SPINNER.ballScaleMultiple,
      },
      {
        // hasProgressBar: true,
        loaderId: 'loader-03',
        // logoUrl: LOGO_URL,

        // isMaster: false,
        spinnerType: SPINNER.ballScaleMultiple,
      },
      { // used
        // hasProgressBar: true,
        loaderId: 'loader-04',
        // isMaster: false,
        spinnerType: SPINNER.ballScaleMultiple,
      },
      {
        // hasProgressBar: false,
        loaderId: 'loader-05',
        // isMaster: false,
        spinnerType: SPINNER.ballScaleMultiple,
        // overlayColor: '#ffffff00',
        // blur: 0
      },
      {
        // hasProgressBar: false,
        loaderId: 'loader-06',
        // isMaster: false,
        spinnerType: SPINNER.ballScaleMultiple,
        // overlayColor: '#ffffff00',
        // blur: 0
      },
      {
        // hasProgressBar: false,
        loaderId: 'loader-07',
        // isMaster: false,
        spinnerType: SPINNER.ballScaleMultiple,
        // overlayColor: '#ffffff00',
        // blur: 0
      },
      {
        // hasProgressBar: false,
        loaderId: 'loader-08',
        // isMaster: false,
        spinnerType: SPINNER.ballScaleMultiple,
        // overlayColor: '#ffffff00',
        // blur: 0
      },
      {
        // hasProgressBar: false,
        loaderId: 'loader-09',
        // isMaster: false,
        spinnerType: SPINNER.ballScaleMultiple,
        // overlayColor: '#ffffff00',
        // blur: 0
      },
      {
        // hasProgressBar: false,
        loaderId: 'loader-10',
        // isMaster: false,
        spinnerType: SPINNER.ballScaleMultiple,
        // overlayColor: '#ffffff00',
        // blur: 0
      },
      {
        // hasProgressBar: false,
        loaderId: 'loader-11',
        // isMaster: false,
        spinnerType: SPINNER.ballScaleMultiple,
        // overlayColor: '#ffffff00',
        // blur: 0
      },
      {
        // hasProgressBar: false,
        loaderId: 'loader-12',
        // isMaster: false,
        spinnerType: SPINNER.ballScaleMultiple,
        // overlayColor: '#ffffff00',
        // blur: 0
      },
      {
        // hasProgressBar: false,
        loaderId: 'loader-13',
        // isMaster: false,
        spinnerType: SPINNER.ballScaleMultiple,
        // overlayColor: '#ffffff00',
        // blur: 0
      },
      {
        // hasProgressBar: false,
        loaderId: 'loader-14',
        // isMaster: false,
        spinnerType: SPINNER.ballScaleMultiple,
        // overlayColor: '#ffffff00',
        // blur: 0
      },
      {
        // hasProgressBar: false,
        loaderId: 'loader-15',
        // isMaster: false,
        spinnerType: SPINNER.ballScaleMultiple,
        // overlayColor: '#ffffff00',
        // blur: 0
      },
      {
        // hasProgressBar: false,
        loaderId: 'loader-16',
        // isMaster: false,
        spinnerType: SPINNER.ballScaleMultiple,
        // overlayColor: '#ffffff00',
        // blur: 0
      },
      {
        // hasProgressBar: false,
        loaderId: 'loader-17',
        // isMaster: false,
        spinnerType: SPINNER.ballScaleMultiple,
        // overlayColor: '#ffffff00',
        // blur: 0
      },
      {
        // hasProgressBar: false,
        loaderId: 'loader-18',
        // isMaster: false,
        spinnerType: SPINNER.ballScaleMultiple,
        // overlayColor: '#ffffff00',
        // blur: 0
      },
      {
        // hasProgressBar: false,
        loaderId: 'loader-19',
        // isMaster: false,
        spinnerType: SPINNER.ballScaleMultiple,
        // overlayColor: '#ffffff00',
        // blur: 0
      },
    ];



  }

  @Input() loader: Loader;

  Highcharts = Highcharts;
  chart: any;
  legendItemVisibility = true;
  userRole: any;
  role: any;
  roleName: any;
  public token: any;
  public id: any;
  login_id: string;
  public logo: any;
  company_name: string;
  isview: any;
  epc_id: string;
  public name: any;
  pipe = new DatePipe('en-US');
  irradiation: any;
  totalTodaysPeakPowerWms: any;
  // showUserTab: any;
  // dataOfNormalUser: any;
  // dataOfNormalUserZE: any;
  // normalUserCount: number;
  // wmsUserCount: any;
  // ZEUserCount: any;
  powergencategories: any = [];
  IrrGraphArray: any = [];
  IrrGraphArray1: any = [];

  IrrGraphArray2: any = [];
  IrrGraphArray3: any = [];

  powerGraphArray: any = [];
  // tslint:disable-next-line:variable-name
  WmsLife_time_Categories: any = [];
  // tslint:disable-next-line:variable-name
  WmsLife_time_Data: any = [];
  // tslint:disable-next-line:variable-name
  wmsmonth_categories: any = [];
  // tslint:disable-next-line:variable-name
  wmsmonth_data: any = [];
  // tslint:disable-next-line:variable-name
  wmsYear_Categories: any = [];
  // tslint:disable-next-line:variable-name
  wmsyear_Data: any = [];
  unit: string;
  // tslint:disable-next-line:variable-name
  unit_capacity: string;
  // tslint:disable-next-line:variable-name
  unit_co2: string;
  deviceAdminObj: { 'search': any; 'limit': any; 'offset': any; 'role': number; };
  dataOfAdminUser: any;
  dataOfAdminZEUser: any;
  wmsAdminUserCount: any;
  adminUserPage = 1;
  selectedTabAdminUserData: any;
  adminNormalUserPage = 1;
  normalAdminUserCount: number;
  zeAdminUserCount: number
  dataOfAdminNormalUser: any;
  // tslint:disable-next-line:variable-name
  admin_id: any;
  through: string;
  DayPowerSumNormalUser: any;
  DaySpcificYeildNormalUser: any;
  DayPowerSumWmsUser: number;
  DaySpcificYeildWmsUser: number;
  DayInsolation: number;
  DayPR: number;
  SadminAccess: any = [];
  SadminAccess1: any = [];
  // tslint:disable-next-line:variable-name
  slave_admin_id: any;

  version = VERSION;
  date1 = new Date();
  chosenYearDate: Date;
  chosenMonthDate: Date = new Date(2020, 0, 1);
  chosenSemesterDate: Date;
  chosenWeekDate: Date;
  chosenDate: Date;
  monthInputCtrl: FormControl = new FormControl(new Date(2020, 0, 1));
  visible = true;
  modelDate = '';
  yearPickerCtrl: FormControl = new FormControl();
  public dayform: FormGroup;
  public monthform: FormGroup;
  public yearform: FormGroup;

  public daywmsform: FormGroup;
  public monthwmsform: FormGroup;
  public yearwmsform: FormGroup;

  public dayzeform: FormGroup;
  public monthzeform: FormGroup;
  public yearzeform: FormGroup;

  public daydgform: FormGroup;
  public monthdgform: FormGroup;
  public yeardgform: FormGroup;

  public AmbientDayGraphform: FormGroup;
  AmbientGraphArray: any = [];
  IrraditionGraphArray: any = [];
  Ambientcategories: any = [];
  page = 1;
  resultObject: any = {};
  resultObjectusserCount: any = {};
  totalUser: any;
  totalDevices: any;
  activeDevices: any;
  inactiveDevices: any;
  epcUser: any;
  cuf: any;
  normalUser: any;
  wmsUser: any;
  totalSolarCapacity: any;
  totalEnergyGenerated: any;
  co2EmmisionSaved: any;
  totalDeviceInstalled: any;
  totalProject: any;
  search: any = '';
  adminUserSearch: any = '';
  adminUserOffset: any = 0;
  adminNormalUserSearch: any = '';
  adminNormalUserOffset: any = 0;
  limit: any = 10;
  offset: any = 0;
  deviceObj: any = {};
  // dataOfUser: any;
  total_energy_consumption: any;
  grid_power: any;
  export: any;
  export_day: any;
  // tslint:disable-next-line:variable-name
  instd_capacity: any;
  totalCurrentPower: any;
  // tslint:disable-next-line: variable-name
  estimated_saving: any;
  totalTodayEnergyGenerated: any;
  totalTodaysPeakPower: any;
  private updateSubscription: Subscription;
  public getNormalUserDashboardDataList: any = {};
  public getNormalUserDeviceInfoDataList: any = {};
  public totalMonthlyEnergyGenerated: any;
  public irradiance: any;
  public pr: any;
  public graphObj: any = {};
  // tslint:disable-next-line:variable-name
  public login_Id = localStorage.login_id;
  public graphData: any;
  public demoArray: any = [];
  // tslint:disable-next-line:variable-name
  public chart_data: any = [];
  // tslint:disable-next-line:variable-name
  public chart_categories: any = [];
  public progress: any = 0;
  public deviceStatus: any = [];
  public deviceErrorStatus: any = [];
  public invErrorStatus: any = [];
  public graphDataArray: any = [];
  public inverterStatus: any = [];
  public meterStatus: any = [];
  public dgstatus: any = [];
  public gridstatus: any = [];
  public selectedTabSection: any;
  public selectedWmsTabSection: any;
  public categories: any = [];
  public data: any = [];
  public normaluserDayGarphArray: any = [];
  public normaluserMonthGarphArray: any = [];
  public normaluserYearGarphArray: any = [];
  public normaluserLifeTimeGarphArray: any = [];
  // tslint:disable-next-line: variable-name
  public month_data: any = [];
  // tslint:disable-next-line:variable-name
  public month_categories: any = [];
  // tslint:disable-next-line:variable-name
  public year_Categories: any = [];
  // tslint:disable-next-line:variable-name
  public year_Data: any = [];
  // public updateFlag = false;
  public updateFlag1 = false;
  public myFormattedDate: any;
  public graphMonthObj: any = {};
  public graphYearObj: any = {};
  public FormattedYear: string;
  // tslint:disable-next-line:variable-name
  public Life_time_Categories: any = [];
  // tslint:disable-next-line:variable-name
  public Life_time_Data: any = [];
  public graphLifeTimeObj: any = {};
  public graphLifeTimeObjWms: any = {};
  public myFormattedMonth: string;
  public inverterDetails: any = [];
  public wmsInverterDetails: any = [];
  public currentDate: Date;
  // public wmscurrentDate: Date;
  public myFormattedYear: any;
  public currentMonth: Date;
  public currentYear: Date;
  inputCtrl: FormControl = new FormControl();
  dt: any;
  maxDate = new Date();
  minDate = new Date(2017, 1, 1);
  // tslint:disable-next-line:variable-name
  instd_capacityUnit: void;
  // tslint:disable-next-line:variable-name
  current_Unit: any;
  totalEnergyGeneratedUnit: any;
  totalTodaysUnit: any;
  totalTodaysPeakPowerUnit: any;
  totalMonthlyEnergyUnit: any;
  irradianceUnit: any;
  // tslint:disable-next-line:variable-name
  estimated_savingUnit: any;
  co2EmmisionSavedUnit: any;
  // tslint:disable-next-line:variable-name
  instd_capacityUnitWms: void;
  // tslint:disable-next-line:variable-name
  current_UnitWms: any;
  totalEnergyGeneratedUnitWms: any;
  totalTodaysUnitWms: any;
  totalTodaysPeakPowerUnitWms: any;
  totalMonthlyEnergyUnitWms: any;
  irradianceUnitWms: any;
  // tslint:disable-next-line:variable-name
  estimated_savingUnitWms: any;
  co2EmmisionSavedUnitWms: any;
  totalMonthlyEnergyGeneratedWms: any;
  // tslint:disable-next-line: variable-name
  instd_capacityWms: any;
  totalTodayEnergyGeneratedWms: any;
  totalCurrentPowerWms: any;
  // tslint:disable-next-line: variable-name
  estimated_savingWms: any;
  totalEnergyGeneratedWms: any;
  co2EmmisionSavedWms: any;
  access: any;
  power: any;
  eng_import: any;
  eng_import_day: any;
  user_id = localStorage.login_id;

  chartOptions = this.highChartService.getHighChartOptions('spline', 'Power (KW)', false);
  chartOptions1 = this.highChartService.getHighChartOptions('column', 'Energy (KWh)', false);
  chartOptions2 = this.highChartService.getHighChartOptions('column', 'Energy (KWh)', true);
  chartOptions3 = this.highChartService.getHighChartOptions('column', 'Energy (KWh)', false);
  // graph Ambient and temp Graph  for wms user dashboard daygraph
  chartOptions4 = {
    chart: {
      type: 'spline'
    },
    tooltip: {
      valueSuffix: '',
      shared: true,
    },
    title: {
      text: 'Temperature and Irradiance'
    },
    xAxis: [{}],
    yAxis: [{ // Primary yAxis
      labels: {
        style: {
          color: Highcharts.getOptions().colors[0]
        }
      },
      title: {
        text: 'Ambient Temp(Degrees)',
        style: {
          color: Highcharts.getOptions().colors[0]
        }
      },


    }, {
      labels: {
        style: {
          color: Highcharts.getOptions().colors[1]
        }
      },
      title: {

        text: 'Irradiance(w/m^2)',
        style: {
          color: Highcharts.getOptions().colors[1]
        }
      },
      opposite: true,

    },],
    series: [{
      name: '',
      yAxis: 0,
      data: []
    },
    {
      name: '',
      yAxis: 1,
      data: []
    }],
    exporting: {
      buttons: {
        contextButton: {
          menuItems: Highcharts.defaultOptions.exporting.buttons.contextButton.menuItems.slice(0, 10)
        }
      }
    }
  };
  chartOptions5 = this.highChartService.getHighChartOprionsAmbientandtemp('spline', 'Power And Irradiance', yaxisDataWNSTodayGraph, false, false);
  chartOptions6 = this.highChartService.getHighChartOptions('column', 'Energy (KWh)', false);
  chartOptions7 = this.highChartService.getHighChartOptions('column', 'Energy (KWh)', false);
  chartOptions8 = this.highChartService.getHighChartOptions('column', 'Energy (KWh)', false);
  // wms user PowerAndIrradition graph is_wms==1, is_emeter =1
  chartOptions11 = this.highChartService.getHighChartOprionsAmbientandtemp('spline', '', yaxisDataZEUserTimeyGraph1, true, true);
  chartOptions12 = this.highChartService.getHighChartOprionsAmbientandtemp('spline', '', yaxisDataChartOptions12, false, false);
  // wms user PowerAndIrradition graph is_wms==0, is_emeter =0
  chartOptions13 = this.highChartService.getHighChartOptions('spline', '', false);
  chartOptions14 = this.highChartService.getHighChartOprionsAmbientandtemp('spline', '', yaxisDataZEUserTimeyGraph, true, false)
  chartOptions15 = this.highChartService.getHighChartOprionsAmbientandtemp('spline', '', yaxisDataChartOptions15, true, false)
 
  addComponentRef(chart: any) {
    chart.parentComponent = this;
  }

  ngOnInit() {

    this.SadminAccess = JSON.parse(localStorage.getItem('SadminAccess') || '[]');
    if (localStorage.SadminAccess !== undefined) {
      this.SadminAccess.forEach(x => {
        if (x.menu_name === 'Dashboard') {
          this.access = x.access;
        }
      });
    }

    Highcharts.setOptions({
      lang: {
        decimalPoint: '.',
        thousandsSep: ''
      }
    });
    /* forms of admin normal */
    this.dayform = this.fb.group({
      dayDate: ['', Validators.required],
    });
    this.monthform = this.fb.group({
      monthYear: ['', Validators.required],
    });

    this.yearform = this.fb.group({
      year: ['', Validators.required],
    });

    // for normal user day graph
    this.dayform.get('dayDate').setValue(this.currentDate = new Date());

    /* forms of ze normal */
    this.dayzeform = this.fb.group({
      dayDate: ['', Validators.required],
    });
    this.monthzeform = this.fb.group({
      monthYear: ['', Validators.required],
    });

    this.yearzeform = this.fb.group({
      year: ['', Validators.required],
    });

    // for normal user day graph
    this.dayzeform.get('dayDate').setValue(this.currentDate = new Date());


    /* forms of dg normal */
    this.daydgform = this.fb.group({
      dayDate: ['', Validators.required],
    });
    this.monthdgform = this.fb.group({
      monthYear: ['', Validators.required],
    });

    this.yeardgform = this.fb.group({
      year: ['', Validators.required],
    });

    // for normal user day graph
    this.daydgform.get('dayDate').setValue(this.currentDate = new Date());

    /* forms of wms normal */

    // wms user day graph form
    this.daywmsform = this.fb.group({
      dayDate: ['', Validators.required],
    });
    // wms user month graph form
    this.monthwmsform = this.fb.group({
      monthYear: ['', Validators.required],
    });
    // wms user year graph form
    this.yearwmsform = this.fb.group({
      year: ['', Validators.required],
    });
    // wms user day graph for ambient form
    this.AmbientDayGraphform = this.fb.group({
      date: ['', Validators.required],
    });
    this.daywmsform.get('dayDate').setValue(new Date());
    this.AmbientDayGraphform.get('date').setValue(new Date());

    // user tab selection
    // this.showUserTab = 'showNormalUserTab';

    if (this.role === '1' || this.role === '5') {
      this.selectedTabAdminUserData = 'adminNormalUserData';
      this.getAdminDashboardData();
      this.totalEnergyGeneratedAdmin();
      this.getDeviceDataOfAdminNormalUser(this.adminNormalUserSearch, this.adminNormalUserOffset, this.limit);
       this.searchAdminUsers();
      this.bnIdle.startWatching(900).subscribe((res) => {
        if (res) {
          this.getAdminDashboardData();
          this.totalEnergyGeneratedAdmin();
        }
      });
    } else if (this.role === '3') {
      this.selectedWmsTabSection = 'WmsDay';
      this.getWmsUserDashboardData();
      this.getWmsDeviceStatus();
      this.getWmsInverterStatus();
      this.getWmsInverterDetails();
      //this.wmsUseAmbientAndIrraditionDayGraph();
      this.dashboardWmsUserPowerAndIrraditionDayGraph();
      // auto call after two min is not active user calulate in second
      this.bnIdle.startWatching(120).subscribe((res) => {
        if (res) {
          this.getWmsUserDashboardData();
          this.getWmsDeviceStatus();
          this.getWmsInverterStatus();
          this.getWmsInverterDetails();
          //this.wmsUseAmbientAndIrraditionDayGraph();
          this.dashboardWmsUserPowerAndIrraditionDayGraph();
        }
      });
    } else if (this.role === '4') {
      this.selectedTabSection = 'Day';
      this.dashboardNormalUserDayGraph();
      this.getNormalUserDashboardData();
      this.getDeviceStatus();
      this.getInverterStatus();
      this.getInverterDetails();

      // auto call after two min is not active user calulate in second
      this.bnIdle.startWatching(120).subscribe((res) => {
        if (res) {
          this.getNormalUserDashboardData();
          this.getDeviceStatus();
          this.getInverterStatus();
          this.getInverterDetails();
          this.dashboardNormalUserDayGraph();
        }
      });
    } else if (this.role === '6' || this.role === '7') {
      this.selectedWmsTabSection = 'WmsDay';
      if (this.role === '6') {
        this.dashboardZEUserDayGraph();
      }
      this.getZEUserDashboardData();
      this.getZEDeviceStatus();
      this.getZEInverterStatus();
      this.getMeterStatus();
      if (this.role === '7') {
        this.getDgStatus();
        this.getGridStatus();
        this.dashboardDGUserGraphDay();
      }

      this.getDeviceNewStatus();
      this.getZEInverterDetails();
      this.getLoadGridPower();
      // auto call after two min is not active user calulate in second
      this.bnIdle.startWatching(120).subscribe((res) => {
        if (res) {
          this.getZEUserDashboardData();
          this.getZEDeviceStatus();
          this.getZEInverterStatus();
          this.getZEInverterDetails();
          if (this.role === '6') {
            this.dashboardZEUserDayGraph();
          }
          this.getMeterStatus();
          if (this.role === '7') {
            this.getDgStatus();
            this.dashboardDGUserGraphDay();
          }
          //  this.getLoadGridPower();
        }
      });
      this.is_wms = localStorage.getItem('is_wms');
      this.is_emeter = localStorage.getItem('is_emeter');

    }
    // if (this.roleName == 'epc') {
    //   this.searchEpcUsers();
    // }

  }

  // searchEpcUsers() {
  //   this.searchSubject.pipe(
  //     debounceTime(500),
  //     distinctUntilChanged(),
  //     takeUntil(this.destroy$),
  //     tap(searchValue => {
  //       if (this.showUserTab == 'showWmsUserTab') {
  //         this.getDeviceDataOfWmsUser(searchValue, this.limit, this.offset);
  //       } else if (this.showUserTab == 'showNormalUserTab') {
  //         this.getDeviceDataOfNormalUser(searchValue, this.limit, this.offset);
  //       } else if (this.showUserTab == 'showZEUserTab') {
  //         this.getDeviceDataOfZEUser(searchValue, this.limit, this.offset);
  //       } else if (this.showUserTab == 'showDGUserTab') {
  //         this.getDeviceDataOfDGUser(searchValue, this.limit, this.offset);
  //       }

  //     })
  //   ).subscribe();
  // }

  searchAdminUsers() {
    this.searchAdminUsersSubject.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      takeUntil(this.destroy$),
      tap(searchValue => {
        if (this.selectedTabAdminUserData == 'adminNormalUserData') {
          this.adminNormalUserSearch = searchValue;
          this.getDeviceDataOfAdminNormalUser(this.adminNormalUserSearch, '0', this.limit);
        } else if (this.selectedTabAdminUserData == 'adminWmsUserData') {
          this.adminUserSearch = searchValue,
            this.getDeviceDataOfAdminWmsUser(this.adminUserSearch, '0', this.limit);
        } else if (this.selectedTabAdminUserData == 'adminZEUserData') {
          this.adminNormalUserSearch = searchValue;
          this.getDeviceDataOfAdminZEUser(this.adminNormalUserSearch, '0', this.limit);
        } else if (this.selectedTabAdminUserData == 'adminDGUserData') {
          this.adminNormalUserSearch = searchValue;
          this.getDeviceDataOfAdminDGUser(this.adminNormalUserSearch, '0', this.limit);
        }

      })
    ).subscribe();
  }
  onSearchAdminUsers(event: KeyboardEvent) {
    this.searchAdminUsersSubject.next((event.target as HTMLInputElement).value.trim());
  }

  // onSearch(event: KeyboardEvent) {
  //   this.searchSubject.next((event.target as HTMLInputElement).value.trim());
  // }
  getLoadGridPower() {

    this.loadGridObject = {
      fromDate: this.datePipe.transform(new Date(), "yyyy-MM-dd"),
      toDate: this.datePipe.transform(new Date(), "yyyy-MM-dd"),
      user_id: this.login_Id

    }
    this.dashboardService.getLoadGrid(this.loadGridObject)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        async result => {

          if (result.status) {
            this.loadGrid = result.resultObject;


            // this.load= this.loadGrid.load;
            // this.power=this.load.power;
            // this.total_energy_consumption = this.load.total_energy_consumption;

            this.load_power = this.loadGrid.load.power;
            this.solar_power = this.loadGrid.solar.power;
            this.dg_power = this.loadGrid.dg.power;


            this.grid_power = this.loadGrid.grid.power;
            this.eng_imp = this.loadGrid.grid.total_energy;
            this.eng_import = this.eng_imp.import;
            this.export = this.eng_imp.export;

            this.eng_imp_day = this.loadGrid.grid.day;
            this.eng_import_day = this.eng_imp_day.import;
            this.export_day = this.eng_imp_day.export;

          } else if (!result.status) {
            if (result.message === 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(['/login']);
            } else {
              this.toastr.error(result.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );




  }

  // viewMoreWmsUserReport
  // viewMoreWmsUserReport() {
  //   const navigationExtras: NavigationExtras = {
  //     queryParams: {
  //       selectedTab: 'wmsUserReport'
  //     }

  //   };
  //   this.router.navigate(['/inject-solar/epc-user-reports'], navigationExtras);
  // }

  // viewMoreNormalUserReport
  // viewMoreNormalUserReport() {
  //   const navigationExtras: NavigationExtras = {
  //     queryParams: {
  //       selectedTab: 'normalUserReport'
  //     }
  //   };
  //   this.router.navigate(['/inject-solar/epc-user-reports'], navigationExtras);
  // }


  //view more ZE user report
  // viewMoreZEUserReport() {
  //   const navigationExtras: NavigationExtras = {
  //     queryParams: {
  //       selectedTab: 'zeUserReport'
  //     }
  //   };
  //   this.router.navigate(['/inject-solar/epc-user-reports'], navigationExtras);
  // }
  //view more DG user report
  // viewMoreDgUserReport() {
  //   const navigationExtras: NavigationExtras = {
  //     queryParams: {
  //       selectedTab: 'dgUserReport'
  //     }
  //   };
  //   this.router.navigate(['/inject-solar/epc-user-reports'], navigationExtras);
  // }

  // show user tab in Epc
  // showWmsUserTab(tab) {
  //   this.showUserTab = tab;
  //   this.getDeviceDataOfWmsUser(this.search, 50, this.offset);
  // }

  // show user tab tab in Epc
  // showNormalUserTab(tab) {
  //   this.showUserTab = tab;
  //   this.getDeviceDataOfNormalUser(this.search, 50, this.offset);
  // }

  // show user ze tab tab in Epc
  // showZEUserTab(tab) {
  //   this.showUserTab = tab;
  //   this.getDeviceDataOfZEUser(this.search, this.limit, this.offset);
  // }

  // show user dg tab tab in Epc
  // showDGUserTab(tab) {
  //   this.showUserTab = tab;
  //   this.getDeviceDataOfDGUser(this.search, this.limit, this.offset);
  // }

  onUsersTabChangeByAdmin(tab: string) {
    this.selectedTabAdminUserData = tab;
    this.srcString = '';
    switch (tab) {
      case 'adminNormalUserData':
        this.adminNormalUserOffset = 0;
        this.getDeviceDataOfAdminNormalUser(this.adminNormalUserSearch, '0', this.limit);
        break;

      case 'adminWmsUserData':
        this.adminUserOffset = 0;
        this.getDeviceDataOfAdminWmsUser(this.adminUserSearch, '0', this.limit);
        break;

      case 'adminZEUserData':
        this.adminUserOffset = 0;
        this.getDeviceDataOfAdminZEUser(this.adminNormalUserSearch, '0', this.limit);
        break;

      case 'adminDGUserData':
        this.adminNormalUserOffset = 0;
        this.getDeviceDataOfAdminDGUser(this.adminNormalUserSearch, '0', this.limit);
        break;

      default:
        console.warn('Unknown tab:', tab);
    }
  }

  // Admin dashboard api call
  getAdminDashboardData() {
    this.dashboardService.getAdminDashboardData()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        async result => {
          if (result.status) {
            this.resultObjectusserCount = result.resultObject;
            this.totalSolarCapacity = this.resultObjectusserCount.totalSolarCapacity;
            this.unit_capacity = 'Kw';
            this.totalUser = this.resultObjectusserCount.totalusers;
            this.totalDevices = this.resultObjectusserCount.totaldevices;
            this.activeDevices = this.resultObjectusserCount.activedevices;
            this.inactiveDevices = this.resultObjectusserCount.inactivedevices;
          } else if (!result.status) {
            if (result.message === 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(['/login']);
            } else {
              this.toastr.error(result.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  // Admin dashboard api call
  totalEnergyGeneratedAdmin() {
    this.ngxUiLoaderService.startBackgroundLoader(this.loaders[1].loaderId);
    this.ngxUiLoaderService.startBackgroundLoader(this.loaders[2].loaderId);
    this.dashboardService.totalEnergyGeneratedAdmin()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        async result => {
          if (result.status) {
            this.resultObjectusserCount = result.resultObject;
            this.totalEnergyGenerated = this.resultObjectusserCount.totalEnergyGenerated;
            if (this.resultObjectusserCount.totalEnergyGenerated >= 1000000) {
              this.totalEnergyGenerated = (this.resultObjectusserCount.totalEnergyGenerated / 1000);
              this.unit = 'MWh';
            } else {
              this.totalEnergyGenerated = this.resultObjectusserCount.totalEnergyGenerated;
              this.unit = 'KWh';
            }
            if (this.resultObjectusserCount.co2EmmisionSaved >= 1000000) {
              this.co2EmmisionSaved = (this.resultObjectusserCount.co2EmmisionSaved / 1000);
              this.unit_co2 = 'Tons';
            } else {
              this.co2EmmisionSaved = this.resultObjectusserCount.co2EmmisionSaved;
              this.unit_co2 = 'Kg';
            }
            this.ngxUiLoaderService.stopBackgroundLoader(this.loaders[1].loaderId);
            this.ngxUiLoaderService.stopBackgroundLoader(this.loaders[2].loaderId);
          } else if (!result.status) {
            if (result.message === 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(['/login']);
              this.ngxUiLoaderService.stopBackgroundLoader(this.loaders[1].loaderId);
              this.ngxUiLoaderService.stopBackgroundLoader(this.loaders[2].loaderId);
            } else {
              this.toastr.error(result.message);
              this.ngxUiLoaderService.stopBackgroundLoader(this.loaders[1].loaderId);
              this.ngxUiLoaderService.stopBackgroundLoader(this.loaders[2].loaderId);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  // EPC dashboard api call
  // getEpcDashboardData() {
  //   this.dashboardService.getDashboardData()
  //     .pipe(takeUntil(this.destroy$))
  //     .subscribe(
  //       async result => {
  //         if (result.status) {
  //           this.resultObject = result.resultObject.dashboardCount;
  //           this.totalEpcUser = this.resultObject.totalusers;
  //           this.totalEpcDevices = this.resultObject.totaldevices;
  //           this.activeEpcDevices = this.resultObject.activedevices;
  //           this.inactiveEpcDevices = this.resultObject.inactivedevices;
  //         } else if (!result.status) {
  //           if (result.message === 'Unauthorised or Login Time-out') {
  //             this.toastr.info(result.message);
  //             this.router.navigate(['/login']);
  //           } else {
  //             this.toastr.error(result.message);
  //           }
  //         }
  //       },
  //       err => {
  //         return console.error(err);
  //       }
  //     );
  // }

  // Normal User dashboard api call
  getNormalUserDashboardData() {
    this.dashboardService.getNormalUserDashboardData()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        async result => {
          if (result.status) {
            const capacity = result.resultObject.instd_capacity;
            const x = capacity.split(' ');
            this.instd_capacity = x[0];
            this.instd_capacityUnit = x[1];
            this.dataService.setLastUpdateAt(result.resultObject.lastUpdatedAt);

            const current = result.resultObject.totalCurrentPower;
            const y = current.split(' ');
            this.totalCurrentPower = y[0];
            this.current_Unit = y[1];

            const todayEnergy = result.resultObject.totalTodayEnergyGenerated;
            if (todayEnergy !== 0 || todayEnergy !== '0') {
              const p = todayEnergy.split(' ');
              this.totalTodayEnergyGenerated = p[0];
              this.totalTodaysUnit = p[1];
            } else {
              this.totalTodayEnergyGenerated = todayEnergy;
              this.totalTodaysUnit = 'KWh';
            }
            const todysPeakpower = result.resultObject.totalTodaysPeakPower;
            const k = todysPeakpower.split(' ');
            this.totalTodaysPeakPower = k[0];
            this.totalTodaysPeakPowerUnit = k[1];
            const totalMonthEnergy = result.resultObject.totalMonthlyEnergyGenerated;
            if (totalMonthEnergy !== 0 || totalMonthEnergy !== '0') {
              const l = totalMonthEnergy.split(' ');
              this.totalMonthlyEnergyGenerated = l[0];
              this.totalMonthlyEnergyUnit = l[1];
            } else {
              this.totalMonthlyEnergyGenerated = totalMonthEnergy;
              this.totalMonthlyEnergyUnit = 'KWh';
            }
            const totalEngergy = result.resultObject.totalEnergyGenerated;
            if (totalEngergy !== 0 || totalEngergy !== '0') {
              const z = totalEngergy.split(' ');
              this.totalEnergyGenerated = z[0];
              this.totalEnergyGeneratedUnit = z[1];
            } else {
              this.totalEnergyGenerated = totalEngergy;
              this.totalEnergyGeneratedUnit = 'KWh';
            }
            const saving = result.resultObject.estimated_saving;
            const h = saving.split(' ');
            this.estimated_saving = h[0];
            this.estimated_savingUnit = h[1];

            const co2Saved = result.resultObject.co2EmmisionSaved;
            const m = co2Saved.split(' ');
            this.co2EmmisionSaved = m[0];
            this.co2EmmisionSavedUnit = m[1];

          } else if (!result.status) {
            if (result.message === 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(['/login']);
            } else {
              this.toastr.error(result.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }


  // wms User dashboard api call
  getWmsUserDashboardData() {
    this.dashboardService.getWmsUserDashboardData()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        async result => {
          if (result.status) {
            const capacity = result.resultObject.instd_capacity;
            this.dataService.setLastUpdateAt(result.resultObject.lastUpdatedAt);
            const x = capacity.split(' ');
            this.instd_capacityWms = x[0];
            this.instd_capacityUnitWms = x[1];

            const todayEnergy = result.resultObject.totalTodayEnergyGenerated;
            if (todayEnergy !== 0 && todayEnergy !== '0') {
              const p = todayEnergy.split(' ');
              this.totalTodayEnergyGeneratedWms = p[0];
              this.totalTodaysUnitWms = p[1];
            } else {
              this.totalTodayEnergyGeneratedWms = todayEnergy;
              this.totalTodaysUnitWms = 'KWh';
            }

            const current = result.resultObject.totalCurrentPower;
            const y = current.split(' ');
            this.totalCurrentPowerWms = y[0];
            this.current_UnitWms = y[1];

            const saving = result.resultObject.estimated_saving;
            const h = saving.split(' ');
            this.estimated_savingWms = h[0];
            this.estimated_savingUnitWms = h[1];


            const co2Saved = result.resultObject.co2EmmisionSaved;
            const m = co2Saved.split(' ');
            this.co2EmmisionSavedWms = m[0];
            this.co2EmmisionSavedUnitWms = m[1];

            const totalEngergy = result.resultObject.totalEnergyGenerated;
            if (totalEngergy !== 0 && totalEngergy !== '0') {
              const z = totalEngergy.split(' ');
              this.totalEnergyGeneratedWms = z[0];
              this.totalEnergyGeneratedUnitWms = z[1];
            } else {
              this.totalEnergyGeneratedWms = totalEngergy;
              this.totalEnergyGeneratedUnitWms = 'KWh';
            }

            const totalMonthEnergy = result.resultObject.totalMonthlyEnergyGenerated;
            if (totalMonthEnergy !== 0 && totalMonthEnergy !== '0') {
              const l = totalMonthEnergy.split(' ');
              this.totalMonthlyEnergyGeneratedWms = l[0];
              this.totalMonthlyEnergyUnitWms = l[1];
            } else {
              this.totalMonthlyEnergyGeneratedWms = totalMonthEnergy;
              this.totalMonthlyEnergyUnitWms = 'KWh';
            }

            const totaltodayspeackpower = result.resultObject.totalTodaysPeakPower;
            const n = totaltodayspeackpower.split(' ');
            this.totalTodaysPeakPowerWms = n[0];
            this.totalTodaysPeakPowerUnitWms = n[1];

            this.irradiance = result.resultObject.irradiance;
            this.irradiation = result.resultObject.irradiation;
            this.pr = result.resultObject.PR;
            this.cuf = result.resultObject.CUF;
          } else if (!result.status) {
            if (result.message === 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(['/login']);
            } else {
              this.toastr.error(result.message);
            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  // ZE User dashboard api call
  getZEUserDashboardData() {
    this.dashboardService.getZEUserDashboardData()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        async result => {
          if (result.status) {
            const capacity = result.resultObject.instd_capacity;
            this.dataService.setLastUpdateAt(result.resultObject.lastUpdatedAt);
            const x = capacity.split(' ');
            this.instd_capacity = x[0];
            this.instd_capacityUnit = x[1];

            const current = result.resultObject.totalCurrentPower;
            const y = current.split(' ');
            this.totalCurrentPower = y[0];
            this.current_Unit = y[1];

            const todayEnergy = result.resultObject.totalTodayEnergyGenerated;
            if (todayEnergy !== 0 || todayEnergy !== '0') {
              const p = todayEnergy.split(' ');
              this.totalTodayEnergyGenerated = p[0];
              this.totalTodaysUnit = p[1];
            } else {
              this.totalTodayEnergyGenerated = todayEnergy;
              this.totalTodaysUnit = 'KWh';
            }
            const todysPeakpower = result.resultObject.totalTodaysPeakPower;
            const k = todysPeakpower.split(' ');
            this.totalTodaysPeakPower = k[0];
            this.totalTodaysPeakPowerUnit = k[1];
            const totalMonthEnergy = result.resultObject.totalMonthlyEnergyGenerated;
            if (totalMonthEnergy !== 0 || totalMonthEnergy !== '0') {
              const l = totalMonthEnergy.split(' ');
              this.totalMonthlyEnergyGenerated = l[0];
              this.totalMonthlyEnergyUnit = l[1];
            } else {
              this.totalMonthlyEnergyGenerated = totalMonthEnergy;
              this.totalMonthlyEnergyUnit = 'KWh';
            }
            const totalEngergy = result.resultObject.totalEnergyGenerated;
            if (totalEngergy !== 0 || totalEngergy !== '0') {
              const z = totalEngergy.split(' ');
              this.totalEnergyGenerated = z[0];
              this.totalEnergyGeneratedUnit = z[1];
            } else {
              this.totalEnergyGenerated = totalEngergy;
              this.totalEnergyGeneratedUnit = 'KWh';
            }
            const saving = result.resultObject.estimated_saving;
            const h = saving.split(' ');
            this.estimated_saving = h[0];
            this.estimated_savingUnit = h[1];

            const co2Saved = result.resultObject.co2EmmisionSaved;
            const m = co2Saved.split(' ');
            this.co2EmmisionSaved = m[0];
            this.co2EmmisionSavedUnit = m[1];

            this.irradiance = result.resultObject.irradiance;
            this.irradiation = result.resultObject.irradiation;
            this.pr = result.resultObject.PR;
            this.cuf = result.resultObject.CUF;

          } else if (!result.status) {
            if (result.message === 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(['/login']);
            } else {
              this.toastr.error(result.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }




  // EPC dashboard api call
  // getEpcDashboardDataInfo() {
  //   this.dashboardService.getDashboardDataInfo()
  //     .pipe(takeUntil(this.destroy$))
  //     .subscribe(
  //       async result => {
  //         if (result.status) {
  //           this.totalEpcSolarCapacity = result.resultObject.totalSolarCapacity;
  //         } else if (!result.status) {
  //           if (result.message === 'Unauthorised or Login Time-out') {
  //             this.toastr.info(result.message);
  //             this.router.navigate(['/login']);
  //           } else {
  //             this.toastr.info(result.message);
  //           }

  //         }
  //       },
  //       err => {
  //         return console.error(err);
  //       }
  //     );
  // }
  // EPC dashboard api call
  // totalEnergyGeneratedEPC() {
  //   this.ngxUiLoaderService.startBackgroundLoader(this.loaders[3].loaderId);
  //   this.ngxUiLoaderService.startBackgroundLoader(this.loaders[4].loaderId);
  //   this.dashboardService.totalEnergyGeneratedEPC()
  //     .pipe(takeUntil(this.destroy$))
  //     .subscribe(
  //       async result => {
  //         if (result.status) {
  //           this.totalEpcEnergyGenerated = result.resultObject.totalEnergyGenerated;
  //           this.co2EmmisionSavedEpc = result.resultObject.co2EmmisionSaved;
  //           this.ngxUiLoaderService.stopBackgroundLoader(this.loaders[3].loaderId);
  //           this.ngxUiLoaderService.stopBackgroundLoader(this.loaders[4].loaderId);
  //         } else if (!result.status) {
  //           if (result.message === 'Unauthorised or Login Time-out') {
  //             this.toastr.info(result.message);
  //             this.router.navigate(['/login']);
  //           } else {
  //             this.toastr.info(result.message);
  //           }
  //           this.ngxUiLoaderService.stopBackgroundLoader(this.loaders[3].loaderId);
  //           this.ngxUiLoaderService.stopBackgroundLoader(this.loaders[4].loaderId);
  //         }
  //       },
  //       err => {
  //         return console.error(err);
  //       }
  //     );
  // }

  // get Device Data of user epc live data
  // getDeviceDataOfWmsUser(search, limit, offset) {
  //   this.dataOfUser = [];
  //   this.ngxUiLoaderService.startBackgroundLoader(this.loaders[5].loaderId);
  //   this.deviceObj = {
  //     search,
  //     limit,
  //     offset,
  //     role: 3,
  //   };
  //   this.dashboardService.getDeviceDataOfUser(this.deviceObj)
  //     .pipe(takeUntil(this.destroy$))
  //     .subscribe(
  //       async result => {
  //         this.wmsUserCount = 0;
  //         if (result.status) {
  //           this.wmsUserCount = result.count;
  //           this.dataOfUser = result.resultObject;
  //           this.ngxUiLoaderService.stopBackgroundLoader(this.loaders[5].loaderId);
  //         } else if (!result.status) {
  //           if (result.message === 'Unauthorised or Login Time-out') {
  //             this.toastr.info(result.message);
  //             this.router.navigate(['/login']);
  //           } else {
  //             this.toastr.info(result.message);
  //           }
  //           this.ngxUiLoaderService.stopBackgroundLoader(this.loaders[5].loaderId);
  //         }
  //       },
  //       err => {
  //         return console.error(err);
  //       }
  //     );
  // }

  // get Device Data of user Admin live data
  getDeviceDataOfAdminWmsUser(search, offset, limit) {
    this.dataOfAdminUser = [];
    this.ngxUiLoaderService.startBackgroundLoader(this.loaders[7].loaderId);
    if (offset === 0) {
      this.adminUserPage = 1;
    }
    this.deviceAdminObj = {
      search,
      limit,
      offset,
      role: 3,
    };
    this.dashboardService.getDeviceDataOfAdminUser(this.deviceAdminObj)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        async result => {
          this.wmsAdminUserCount = 0;
          if (result.status) {
            this.ngxUiLoaderService.stopBackgroundLoader(this.loaders[7].loaderId);
            this.wmsAdminUserCount = result.count;
            this.dataOfAdminUser = result.resultObject;
          } else if (!result.status) {
            if (result.message === 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(['/login']);
            } else {
              this.toastr.info(result.message);
            }
            this.ngxUiLoaderService.stopBackgroundLoader(this.loaders[7].loaderId);
          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  // get Device Data of user Admin normal live data
  getDeviceDataOfAdminNormalUser(search, offset, limit) {
    this.dataOfAdminNormalUser = [];
    this.ngxUiLoaderService.startBackgroundLoader(this.loaders[8].loaderId);
    if (offset === 0) {
      this.adminNormalUserPage = 1;
    }
    this.deviceAdminObj = {
      search,
      limit,
      offset,
      role: 4,
    };
    this.dashboardService.getDeviceDataOfAdminUser(this.deviceAdminObj)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        async result => {
          this.normalAdminUserCount = 0;
          if (result.status) {
            this.ngxUiLoaderService.stopBackgroundLoader(this.loaders[8].loaderId);
            this.normalAdminUserCount = result.count;
            this.dataOfAdminNormalUser = result.resultObject;
          } else if (!result.status) {
            if (result.message === 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(['/login']);
            } else {
              this.toastr.info(result.message);
            }
            this.ngxUiLoaderService.startBackgroundLoader(this.loaders[8].loaderId);
          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  // get Device Data of user ZE live data
  getDeviceDataOfAdminZEUser(search, offset, limit) {

    this.dataOfAdminNormalUser = [];
    this.ngxUiLoaderService.startBackgroundLoader(this.loaders[9].loaderId);
    if (offset === 0) {
      this.adminNormalUserPage = 1;
    }
    this.deviceAdminObj = {
      search,
      limit,
      offset,
      role: 6,
    };
    this.dashboardService.getDeviceDataOfAdminUser(this.deviceAdminObj)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        async result => {
          this.zeAdminUserCount = 0;
          if (result.status) {
            this.ngxUiLoaderService.stopBackgroundLoader(this.loaders[9].loaderId);
            this.zeAdminUserCount = result.count;
            this.dataOfAdminZEUser = result.resultObject;
          } else if (!result.status) {
            if (result.message === 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(['/login']);
            } else {
              this.toastr.info(result.message);
            }
            this.ngxUiLoaderService.startBackgroundLoader(this.loaders[9].loaderId);
          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  // get Device Data of user ZE live data
  getDeviceDataOfAdminDGUser(search, offset, limit) {
    this.dataOfAdminNormalUser = [];
    this.ngxUiLoaderService.startBackgroundLoader(this.loaders[10].loaderId);
    if (offset === 0) {
      this.adminNormalUserPage = 1;
    }
    this.deviceAdminObj = {
      search,
      limit,
      offset,
      role: 7,
    };
    this.dashboardService.getDeviceDataOfAdminUser(this.deviceAdminObj)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        async result => {
          this.dgAdminUserCount = 0;
          if (result.status) {
            this.ngxUiLoaderService.stopBackgroundLoader(this.loaders[10].loaderId);
            this.dgAdminUserCount = result.count;
            this.dataOfAdminNormalUser = result.resultObject;
          } else if (!result.status) {
            if (result.message === 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(['/login']);
            } else {
              this.toastr.info(result.message);
            }
            this.ngxUiLoaderService.startBackgroundLoader(this.loaders[10].loaderId);
          }
        },
        err => {
          return console.error(err);
        }
      );
  }


  // admin wms user Data Page change
  nextPageAdminWmsUser(page): void {
    this.adminUserOffset = (page - 1) * 10;
    this.getDeviceDataOfAdminWmsUser(this.adminUserSearch, this.adminUserOffset, this.limit);
  }

  // admin normal user Data Page change
  nextPageAdminNormalUser(page): void {
    this.adminNormalUserOffset = (page - 1) * 10;
    this.getDeviceDataOfAdminNormalUser(this.adminNormalUserSearch, this.adminNormalUserOffset, this.limit);
  }
  nextPageAdminNormalUserZE(page): void {
    this.adminNormalUserOffset = (page - 1) * 10;
    this.getDeviceDataOfAdminZEUser(this.adminNormalUserSearch, this.adminNormalUserOffset, this.limit);
  }
  nextPageAdminNormalUserDG(page): void {
    this.adminNormalUserOffset = (page - 1) * 10;
    this.getDeviceDataOfAdminDGUser(this.adminNormalUserSearch, this.adminNormalUserOffset, this.limit);
  }

  // get Device Data of user epc live data
  // getDeviceDataOfNormalUser(search, limit, offset) {
  //   this.dataOfNormalUser = [];
  //   this.ngxUiLoaderService.startBackgroundLoader(this.loaders[6].loaderId);
  //   this.deviceObj = {
  //     search,
  //     limit,
  //     offset,
  //     role: 4,
  //   };
  //   this.dashboardService.getDeviceDataOfUser(this.deviceObj)
  //     .pipe(takeUntil(this.destroy$))
  //     .subscribe(
  //       async result => {
  //         this.normalUserCount = 0;
  //         if (result.status) {
  //           this.normalUserCount = result.count;
  //           this.dataOfNormalUser = result.resultObject;


  //           this.ngxUiLoaderService.stopBackgroundLoader(this.loaders[6].loaderId);
  //         } else if (!result.status) {
  //           if (result.message === 'Unauthorised or Login Time-out') {
  //             this.toastr.info(result.message);
  //             this.router.navigate(['/login']);
  //           } else {
  //             this.toastr.info(result.message);
  //           }
  //           this.ngxUiLoaderService.stopBackgroundLoader(this.loaders[6].loaderId);
  //         }
  //       },
  //       err => {
  //         return console.error(err);
  //       }
  //     );
  // }


  // get Device Data of ze user epc live data
  // getDeviceDataOfZEUser(search, limit, offset) {

  //   this.dataOfNormalUserZE = [];
  //   this.ngxUiLoaderService.startBackgroundLoader(this.loaders[11].loaderId);
  //   this.deviceObj = {
  //     search,
  //     limit,
  //     offset,
  //     role: 6,
  //   };
  //   this.dashboardService.getDeviceDataOfUser(this.deviceObj)
  //     .pipe(takeUntil(this.destroy$))
  //     .subscribe(
  //       async result => {
  //         this.ZEUserCount = 0;
  //         if (result.status) {
  //           this.ZEUserCount = result.count;
  //           this.dataOfNormalUserZE = result.resultObject;


  //           this.ngxUiLoaderService.stopBackgroundLoader(this.loaders[11].loaderId);
  //         } else if (!result.status) {
  //           if (result.message === 'Unauthorised or Login Time-out') {
  //             this.toastr.info(result.message);
  //             this.router.navigate(['/login']);
  //           } else {
  //             this.toastr.info(result.message);
  //           }
  //           this.ngxUiLoaderService.stopBackgroundLoader(this.loaders[11].loaderId);
  //         }
  //       },
  //       err => {
  //         return console.error(err);
  //       }
  //     );
  // }
  // get Device Data of dg user epc live data
  // getDeviceDataOfDGUser(search, limit, offset) {
  //   this.dataOfNormalUser = [];
  //   this.ngxUiLoaderService.startBackgroundLoader(this.loaders[12].loaderId);
  //   this.deviceObj = {
  //     search,
  //     limit,
  //     offset,
  //     role: 7,
  //   };
  //   this.dashboardService.getDeviceDataOfUser(this.deviceObj)
  //     .pipe(takeUntil(this.destroy$))
  //     .subscribe(
  //       async result => {
  //         this.DGUserCount = 0;
  //         if (result.status) {
  //           this.DGUserCount = result.count;
  //           this.dataOfNormalUser = result.resultObject;
  //           this.ngxUiLoaderService.stopBackgroundLoader(this.loaders[12].loaderId);
  //         } else if (!result.status) {
  //           if (result.message === 'Unauthorised or Login Time-out') {
  //             this.toastr.info(result.message);
  //             this.router.navigate(['/login']);
  //           } else {
  //             this.toastr.info(result.message);
  //           }
  //           this.ngxUiLoaderService.stopBackgroundLoader(this.loaders[12].loaderId);
  //         }
  //       },
  //       err => {
  //         return console.error(err);
  //       }
  //     );
  // }

  // Tab selection of normal user tab data
  showAllLifeTimeGraphTab(selectedTabSection) {
    this.selectedTabSection = selectedTabSection;
    this.dashboardNormalUseLifeTimeGraph();
  }
  showAllLifeTimeGraphTabZE(selectedTabSection) {
    this.selectedWmsTabSection = selectedTabSection;
    this.dashboardZEUseLifeTimeGraph();
  }
  showAllLifeTimeGraphTabDG(selectedTabSection) {
    this.selectedTabSection = selectedTabSection;
    this.dashboardDGUseLifeTimeGraph();
  }
  showAllYearGraphTab(selectedTabSection) {
    this.selectedTabSection = selectedTabSection;
    this.yearform.get('year').setValue(this.currentDate = new Date());
    this.dashboardNormalUseYearGraph();
  }

  showAllYearGraphTabDG(selectedTabSection) {
    this.selectedTabSection = selectedTabSection;
    this.yearform.get('year').setValue(this.currentDate = new Date());
    this.dashboardDGUseYearGraph();
  }

  showAllYearGraphTabZE(selectedTabSection) {
    this.selectedWmsTabSection = selectedTabSection;
    this.yearwmsform.get('year').setValue(this.currentDate = new Date());
    this.dashboardZEUseYearGraph();
  }

  showAllMonthGraphTab(selectedTabSection) {
    this.selectedTabSection = selectedTabSection;
    this.monthform.get('monthYear').setValue(this.currentDate = new Date());
    this.dashboardNormalUserMonthGraph();
  }

  showAllMonthGraphTabDG(selectedTabSection) {
    this.selectedTabSection = selectedTabSection;
    this.monthwmsform.get('monthYear').setValue(this.currentDate = new Date());
    this.dashboardDGUserMonthGraph();
  }
  showAllMonthGraphTabZE(selectedTabSection) {
    this.selectedWmsTabSection = selectedTabSection;
    this.monthwmsform.get('monthYear').setValue(new Date());
    this.dashboardZEUserMonthGraph();
  }
  showAllDayGraphTab(selectedTabSection) {
    this.dayform.get('dayDate').setValue(this.currentDate = new Date());
    this.selectedTabSection = selectedTabSection;
    this.dashboardNormalUserDayGraph();
  }

  showAllDayGraphTabZE(selectedTabSection) {
    this.selectedWmsTabSection = selectedTabSection;
    this.daywmsform.get('dayDate').setValue(this.currentDate = new Date());
    if (this.role === '6') {
      this.dashboardZEUserDayGraph();
    }

    if (this.role === '7') {
      this.dashboardDGUserGraphDay();
    }
  }

  showAllDayGraphTabDG(selectedTabSection) {
    this.dayform.get('dayDate').setValue(this.currentDate = new Date());
    this.selectedWmsTabSection = selectedTabSection;
    this.dashboardDGUserDayGraph();
  }
  // tab selection of wms user data
  showAllLifeTimeGraphTabWms(selectedTabSection) {
    this.selectedWmsTabSection = selectedTabSection;
    this.dashboarWmsUseLifeTimeGraph();
  }
  showAllYearGraphTabWms(selectedTabSection) {
    this.selectedWmsTabSection = selectedTabSection;
    this.yearwmsform.get('year').setValue(new Date());
    this.chosenYearHandlerWms();
  }
  showAllMonthGraphTabWms(selectedTabSection) {
    this.selectedWmsTabSection = selectedTabSection;
    this.monthwmsform.get('monthYear').setValue(new Date());
    this.dashboardWmsUserMonthGraph();
  }
  showAllDayGraphTabWms(selectedTabSection) {
    this.selectedWmsTabSection = selectedTabSection;
    this.daywmsform.get('dayDate').setValue(new Date());
    this.dashboardWmsUserPowerAndIrraditionDayGraph();

  }

  // when date change AmbientAndIrraditionDayGraph wms user
  dateChange() {
    this.wmsUseAmbientAndIrraditionDayGraph();
  }
  // when date change powerAndIrraditionDayGraph wms user
  onWmsDateChange() {
    this.dashboardWmsUserPowerAndIrraditionDayGraph();
  }

  onZEDateChange() {
    // console.log(this.role)
    if (this.role === '6') {
      this.dashboardZEUserDayGraph();
    }
    if (this.role === '7') {
      this.dashboardDGUserGraphDay();
    }
  }

  /**NORMAL USER */
  // Dynamic DayGraph for normal user
  public dashboardNormalUserDayGraph() {
    // var pipe = new DatePipe('en-US')
    // this.myFormattedDate = pipe.transform(this.currentDate, );
    this.graphObj = {
      date: this.pipe.transform(this.dayform.controls.dayDate.value, 'dd-MM-yyyy'),
      user_id: this.login_Id,
    };
    this.dashboardService.dashboardNormalUserEnergyDayGraph(this.graphObj)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        async result => {
          this.categories = [];
          this.data = [];
          this.normaluserDayGarphArray = [];
          if (result.status) {
            this.DayPowerSumNormalUser = result.sum_power_gen.toFixed(2);
            this.DaySpcificYeildNormalUser = result.specific_yeild.toFixed(2);
            this.normaluserDayGarphArray = result.resultObject;
            // tslint:disable-next-line: prefer-for-of
            for (let i = 0; i < this.normaluserDayGarphArray.length; i++) {
              if (this.normaluserDayGarphArray[i].date_time) {
                const stringToSplit = this.normaluserDayGarphArray[i].date_time;
                const x = stringToSplit.split(' ');
                this.categories.push(x[1]);
                this.data.push(Number(this.normaluserDayGarphArray[i].power_generation));
              }
            }
            this.chartOptions.series = [{
              name: 'Power Generated in KW',
              data: this.data
            },];

            this.chartOptions.xAxis = [{
              categories: this.categories
            },];

            this.chartOptions = JSON.parse(JSON.stringify(this.chartOptions))

          } else if (!result.status) {
            if (result.message === 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(['/login']);
            } else {
              this.toastr.info(result.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  // Dynamic monthgraph for normal user
  public dashboardNormalUserMonthGraph() {
    this.graphMonthObj = {
      month: this.pipe.transform(this.monthform.controls.monthYear.value, 'MM'),
      year: this.pipe.transform(this.monthform.controls.monthYear.value, 'yyyy'),
      user_id: this.login_Id,
    };
    this.dashboardService.dashboardNormalUserEnergyMonthGraph(this.graphMonthObj)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        async result => {
          this.month_categories = [];
          this.month_data = [];
          this.monthPowerSumNormalUser = 0;
          this.normalGraphSpicificYeild = 0;
          this.normaluserMonthGarphArray = [];
          if (result.status) {

            this.monthPowerSumNormalUser = result.sum_power_gen.toFixed(2);
            this.normalGraphSpicificYeild = result.specific_yeild.toFixed(2);
            this.normaluserMonthGarphArray = result.resultObject;
            // tslint:disable-next-line: prefer-for-of
            for (let i = 0; i < this.normaluserMonthGarphArray.length; i++) {
              if (this.normaluserMonthGarphArray[i].date) {
                this.month_categories.push(this.normaluserMonthGarphArray[i].date);
                this.month_data.push(Number(this.normaluserMonthGarphArray[i].power_generation));
              }
            }
            // render data for chart
            this.chartOptions1.series = [{
              name: 'Energy Generated in KWh',
              data: this.month_data
            },];
            this.chartOptions1.xAxis = [{
              categories: this.month_categories
            },];
            this.chartOptions1 = JSON.parse(JSON.stringify(this.chartOptions1))
            // this.updateFlag = true;
          } else if (!result.status) {
            if (result.message === 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(['/login']);
            } else {
              this.toastr.info(result.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  // Dynamic yeargraph for normal user
  public dashboardNormalUseYearGraph() {
    this.graphYearObj = {
      year: this.pipe.transform(this.yearform.controls.year.value, 'yyyy'),
      user_id: this.login_Id,
    };
    this.dashboardService.dashboardNormalUserEnergyYearGraph(this.graphYearObj)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        async result => {
          this.year_Categories = [];
          this.year_Data = [];
          this.yearPowerSumNormalUser = 0;
          this.yearSpicificYeildNormalUser = 0;
          this.normaluserYearGarphArray = [];
          if (result.status) {
            this.yearPowerSumNormalUser = result.sum_power_gen.toFixed(2);
            this.yearSpicificYeildNormalUser = result.specific_yeild.toFixed(2);
            this.normaluserYearGarphArray = result.resultObject;
            // tslint:disable-next-line:prefer-for-of
            for (let i = 0; i < this.normaluserYearGarphArray.length; i++) {
              if (this.normaluserYearGarphArray[i].month) {
                this.year_Categories.push(this.normaluserYearGarphArray[i].month);
                this.year_Data.push(this.normaluserYearGarphArray[i].power_generation);
              }
            }
            // update graph Serise
            this.chartOptions2.series = [{
              name: 'Energy Generated in KWh',
              data: this.year_Data
            },];
            this.chartOptions2.xAxis = [{
              categories: this.year_Categories
            },];
            this.chartOptions2 = JSON.parse(JSON.stringify(this.chartOptions2));
            // this.updateFlag = true;
          } else if (!result.status) {
            if (result.message === 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(['/login']);
            } else {
              this.toastr.info(result.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  // Dynamic lifetime graph for normal user
  public dashboardNormalUseLifeTimeGraph() {
    this.graphLifeTimeObj = {
      start_year: '2017',
      user_id: this.login_Id,
    };
    this.dashboardService.dashboardNormalUserEnergyLifeTimeGraph(this.graphLifeTimeObj)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        async result => {
          this.Life_time_Categories = [];
          this.Life_time_Data = [];
          this.lifeTimePowerSumNormalUser = 0;
          this.normaluserLifeTimeGarphArray = [];
          if (result.status) {
            this.lifeTimePowerSumNormalUser = result.sum_power_gen.toFixed(2);
            this.normaluserLifeTimeGarphArray = result.resultObject;
            // tslint:disable-next-line:prefer-for-of
            for (let i = 0; i < this.normaluserLifeTimeGarphArray.length; i++) {
              if (this.normaluserLifeTimeGarphArray[i].year) {
                this.Life_time_Categories.push(this.normaluserLifeTimeGarphArray[i].year);
                this.Life_time_Data.push(Number(this.normaluserLifeTimeGarphArray[i].power_generation));
              }
            }
            // update graph serise
            this.chartOptions3.series = [{
              name: 'Energy Generated in KWh',
              data: this.Life_time_Data
            },];
            this.chartOptions3.xAxis = [{
              categories: this.Life_time_Categories
            },];
            // this.updateFlag = true;
            this.chartOptions3 = JSON.parse(JSON.stringify(this.chartOptions3));
          } else if (!result.status) {
            if (result.message === 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(['/login']);
            } else {
              this.toastr.info(result.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  /*NORMAL USER*/

  // dynamic DG day graph for DG user R
  public dashboardDGUserGraphDay() {
    this.is_wms = localStorage.getItem('is_wms');
    this.is_emeter = localStorage.getItem('is_emeter');
    // var pipe = new DatePipe('en-US')
    // this.myFormattedDate = pipe.transform(this.currentDate, );
    this.graphObj = {
      date: this.pipe.transform(this.daywmsform.controls.dayDate.value, 'dd-MM-yyyy'),
      user_id: this.login_Id,
    };
    this.dashboardService.dashboardUserEnergyDayGraphDG(this.graphObj)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        async result => {
          this.categories = [];
          this.data = [];
          this.normaluserDayGarphArray = [];
          this.powerGraphArray = [];
          this.IrrGraphArray = [];
          this.IrrGraphArray1 = [];
          this.IrrGraphArray2 = [];
          this.IrrGraphArray3 = [];
          this.IrrGraphArray4 = [];
          this.IrrGraphArray5 = [];
          this.DayPowerSumWmsUser = 0;
          this.DaySpcificYeildWmsUser = 0;
          this.DayInsolation=0;
          this.DayPR=0;
          // this.spp=[]
          if (result.status) {
            this.DayPowerSumWmsUser = result.sum_power_gen.toFixed(2);
            this.DaySpcificYeildWmsUser = result.specific_yeild.toFixed(2);
             this.DayInsolation = result.insolation;
            this.DayPR =result.pr;
            const powerGraphArray = result.resultObject.power_generation;
            const IrrGraphArray = result.resultObject.IrrData;
            const IrrGraphArray1 = result.resultObject.load_power_data;
            const IrrGraphArray2 = result.resultObject.solar_power_data;
            const IrrGraphArray3 = result.resultObject.grid_power_data;
            const IrrGraphArray4 = result.resultObject.dg_power_data;
            const IrrGraphArray5 = result.resultObject.IrrData;

            // const spp = result.resultObject.spp;
            for (let i = 0; i < IrrGraphArray.length; i++) {
              if (IrrGraphArray[i].date_time) {
                this.IrrGraphArray.push(Number(IrrGraphArray[i].power_generation));
              }
            }
            for (let i = 0; i < IrrGraphArray1.length; i++) {
              if (IrrGraphArray1[i].date_time) {
                this.IrrGraphArray1.push(Number(IrrGraphArray1[i].load_power));
              }
            }
            for (let i = 0; i < IrrGraphArray2.length; i++) {
              if (IrrGraphArray2[i].date_time) {
                this.IrrGraphArray2.push(Number(IrrGraphArray2[i].solar_power));
              }
            }
            for (let i = 0; i < IrrGraphArray3.length; i++) {
              if (IrrGraphArray3[i].date_time) {
                this.IrrGraphArray3.push(Number(IrrGraphArray3[i].grid_power));
              }
            }
            for (let i = 0; i < powerGraphArray.length; i++) {
              this.powerGraphArray.push(Number(powerGraphArray[i].power_generation));
              const stringToSplit = powerGraphArray[i].date_time;
              const x = stringToSplit.split(' ');
              this.powergencategories.push(x[1]);
            }

            for (let i = 0; i < IrrGraphArray4.length; i++) {
              // console.log(IrrGraphArray4[i].date_time)
              if (IrrGraphArray4[i].date_time) {
                this.IrrGraphArray4.push(Number(IrrGraphArray4[i].dg_power));
              }
              // console.log(IrrGraphArray4)
            }

            for (let i = 0; i < IrrGraphArray5.length; i++) {
              // console.log(IrrGraphArray4[i].date_time)
              if (IrrGraphArray5[i].date_time) {
                this.IrrGraphArray5.push(Number(IrrGraphArray5[i].value));
              }
              // console.log(IrrGraphArray4)
            }
            // for (let i = 0; i < spp.length; i++) {
            //   this.spp.push(Number(spp[i].spp));
            //   const stringToSplit = spp[i].date_time;
            //   const x = stringToSplit.split(' ');
            //   this.powergencategories.push(x[1]);


            // }

            // update graph serise
            if (this.is_wms == 1 && this.is_emeter == 1) {
              this.chartOptions11.series = [
                //   {
                //   name: 'Power Generated(KW)',
                //   yAxis: 0,
                //    data: this.powerGraphArray

                // },
                {
                  name: 'Irradiance(w/m^2)',
                  yAxis: 0,
                  data: this.IrrGraphArray5
                },
                {
                  name: 'Load Power (KW)',
                  yAxis: 1,
                  data: this.IrrGraphArray1
                },
                {
                  name: 'Solar Power (KW)',
                  yAxis: 2,
                  data: this.IrrGraphArray2
                },
                {
                  name: 'Grid Power (KW)',
                  yAxis: 3,
                  data: this.IrrGraphArray3
                },
                {
                  name: 'DG Power (KW)',
                  yAxis: 4,
                  data: this.IrrGraphArray4
                },
                // {
                //   name: 'SPP (%)',
                //   yAxis: 4,
                //   data: this.spp
                // },
              ];

              this.chartOptions11.xAxis = [{
                categories: this.powergencategories
              },];
              // this.updateFlag = true;
              this.chartOptions11 = JSON.parse(JSON.stringify(this.chartOptions11));
            }

            else if (this.is_wms == 1 && this.is_emeter == 0) {
              this.chartOptions12.series = [
                //   {
                //   name: 'Power Generated(KW)',
                //   yAxis: 0,
                //   data: this.powerGraphArray
                // },

                {
                  name: 'Irradiance(w/m^2)',
                  yAxis: 0,
                  data: this.IrrGraphArray5
                },

                {
                  name: 'Load Power (KW)',
                  yAxis: 1,
                  data: this.IrrGraphArray1
                },
                {
                  name: 'Solar Power (KW)',
                  yAxis: 2,
                  data: this.IrrGraphArray2
                },
                {
                  name: 'Grid Power (KW)',
                  yAxis: 3,
                  data: this.IrrGraphArray3
                },
                {
                  name: 'DG Power (KW)',
                  yAxis: 4,
                  data: this.IrrGraphArray4
                },

                /* {
                  name: 'DG Power (KW)',
                  yAxis: 1,
                  data: this.IrrGraphArray4
                }, */
              ];

              this.chartOptions12.xAxis = [{
                categories: this.powergencategories
              },];
              // this.updateFlag = true;
              this.chartOptions12 = JSON.parse(JSON.stringify(this.chartOptions12));
            }
            else if (this.is_wms == 0 && this.is_emeter == 0) {
              this.chartOptions13.series = [
                //   {
                //   name: 'Power Generated(KW)',
                //   yAxis: 0,
                //   data: this.powerGraphArray
                // },
                // {
                //   name: 'SPP',
                //   yAxis: 1,
                //   data: this.spp
                // },


              ];

              this.chartOptions13.xAxis = [{
                categories: this.powergencategories
              },];
              this.chartOptions13 = JSON.parse(JSON.stringify(this.chartOptions13));
              // this.updateFlag = true;
            }

            else if (this.is_wms == 0 && this.is_emeter == 1) {
              this.chartOptions15.series = [
                //   {
                //   name: 'Power Generated(KW)',
                //   yAxis: 0,
                //   data: this.powerGraphArray
                // },

                {
                  name: 'Load Power (KW)',
                  yAxis: 0,
                  data: this.IrrGraphArray1
                },
                {
                  name: 'Solar Power (KW)',
                  yAxis: 1,
                  data: this.IrrGraphArray2
                },
                {
                  name: 'Grid Power (KW)',
                  yAxis: 2,
                  data: this.IrrGraphArray3
                },
                {
                  name: 'DG Power (KW)',
                  yAxis: 3,
                  data: this.IrrGraphArray4
                },

                // {
                //   name: 'Irradiance(w/m^2)',
                //   yAxis: 3,
                //   data: this.IrrGraphArray5
                // },
                // {
                //   name: 'SPP (%)',
                //   yAxis: 3,
                //   data: this.spp
                // },
              ];
              this.chartOptions15.xAxis = [{
                categories: this.powergencategories
              },];
              // this.updateFlag = true;
              this.chartOptions15 = JSON.parse(JSON.stringify(this.chartOptions15));
            }

          } else if (!result.status) {
            if (result.message === 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(['/login']);
            } else {
              this.toastr.info(result.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  /**-------------------ZE USER------------ */
  // Dynamic DayGraph for ZE user
  public dashboardZEUserDayGraph() {
    this.is_wms = localStorage.getItem('is_wms');
    this.is_emeter = localStorage.getItem('is_emeter');

    // var pipe = new DatePipe('en-US')
    // this.myFormattedDate = pipe.transform(this.currentDate, );
    this.graphObj = {
      date: this.pipe.transform(this.daywmsform.controls.dayDate.value, 'dd-MM-yyyy'),
      user_id: this.login_Id,
    };
    this.dashboardService.dashboardZEUserEnergyDayGraph(this.graphObj)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        async result => {
          this.categories = [];
          this.data = [];
          this.normaluserDayGarphArray = [];
          this.powerGraphArray = [];
          this.IrrGraphArray = [];
          this.IrrGraphArray1 = [];
          this.IrrGraphArray2 = [];
          this.IrrGraphArray3 = [];
          this.DayPowerSumWmsUser = 0;
          this.DaySpcificYeildWmsUser = 0;
           this.DayInsolation = 0;
            this.DayPR =0;
          // this.spp=[]
          if (result.status) {
            this.DayPowerSumWmsUser = result.sum_power_gen.toFixed(2);
            this.DaySpcificYeildWmsUser = result.specific_yeild.toFixed(2);
            this.DayInsolation = result.insolation;
            this.DayPR =result.pr;
            const powerGraphArray = result.resultObject.power_generation;
            const IrrGraphArray = result.resultObject.IrrData;
            const IrrGraphArray1 = result.resultObject.load_power_data;
            const IrrGraphArray2 = result.resultObject.solar_power_data;
            const IrrGraphArray3 = result.resultObject.grid_power_data;
            // const IrrGraphArray4 = result.resultObject.dg_power_data;
            // const spp = result.resultObject.spp;
            for (let i = 0; i < IrrGraphArray.length; i++) {
              if (IrrGraphArray[i].date_time) {
                this.IrrGraphArray.push(Number(IrrGraphArray[i].value));
              }
            }
            for (let i = 0; i < IrrGraphArray1.length; i++) {
              if (IrrGraphArray1[i].date_time) {
                this.IrrGraphArray1.push(Number(IrrGraphArray1[i].load_power));
              }
            }
            for (let i = 0; i < IrrGraphArray2.length; i++) {
              if (IrrGraphArray2[i].date_time) {
                this.IrrGraphArray2.push(Number(IrrGraphArray2[i].solar_power));
              }
            }
            for (let i = 0; i < IrrGraphArray3.length; i++) {
              if (IrrGraphArray3[i].date_time) {
                this.IrrGraphArray3.push(Number(IrrGraphArray3[i].grid_power));
              }
            }
            for (let i = 0; i < powerGraphArray.length; i++) {
              this.powerGraphArray.push(Number(powerGraphArray[i].power_generation));
              const stringToSplit = powerGraphArray[i].date_time;
              const x = stringToSplit.split(' ');
              this.powergencategories.push(x[1]);
            }

            /* R for (let i = 0; i < IrrGraphArray4.length; i++) {
              if (IrrGraphArray4[i].date_time) {
                this.IrrGraphArray4.push(Number(IrrGraphArray4[i].dg_power));
              }
            } ER*/
            // for (let i = 0; i < spp.length; i++) {
            //   this.spp.push(Number(spp[i].spp));
            //   const stringToSplit = spp[i].date_time;
            //   const x = stringToSplit.split(' ');
            //   this.powergencategories.push(x[1]);


            // }

            // update graph serise

            if (this.is_wms == 1 && this.is_emeter == 1) {
              this.chartOptions11.series = [
                //   {
                //   name: 'Power Generated(KW)',
                //   yAxis: 0,
                //    data: this.powerGraphArray

                // },

                {
                  name: 'Irradiance(w/m^2)',
                  yAxis: 0,
                  data: this.IrrGraphArray,
                },
                {
                  name: 'Load Power (KW)',
                  yAxis: 1,
                  data: this.IrrGraphArray1
                },
                {
                  name: 'Solar Power (KW)',
                  yAxis: 2,
                  data: this.IrrGraphArray2
                },
                {
                  name: 'Grid Power (KW)',
                  yAxis: 3,
                  data: this.IrrGraphArray3
                },
                /* R {
                   name: 'DG Power (KW)',
                   yAxis: 3,
                   data: this.IrrGraphArray4
                 },ER */
                // {
                //   name: 'SPP (%)',
                //   yAxis: 4,
                //   data: this.spp
                // },
              ];

              this.chartOptions11.xAxis = [{
                categories: this.powergencategories
              },];
              // this.updateFlag = true;
              this.chartOptions11 = JSON.parse(JSON.stringify(this.chartOptions11));
            }

            else if (this.is_wms == 1 && this.is_emeter == 0) {
              this.chartOptions12.series = [
                //   {
                //   name: 'Power Generated(KW)',
                //   yAxis: 0,
                //   data: this.powerGraphArray
                // },

                {
                  name: 'Irradiance(w/m^2)',
                  yAxis: 0,
                  data: this.IrrGraphArray
                },

              ];

              this.chartOptions12.xAxis = [{
                categories: this.powergencategories
              },];
              this.chartOptions12 = JSON.parse(JSON.stringify(this.chartOptions12));
              // this.updateFlag = true;
            }
            else if (this.is_wms == 0 && this.is_emeter == 0) {
              this.chartOptions13.series = [
                //   {
                //   name: 'Power Generated(KW)',
                //   yAxis: 0,
                //   data: this.powerGraphArray
                // },
                // {
                //   name: 'SPP',
                //   yAxis: 1,
                //   data: this.spp
                // },


              ];

              this.chartOptions13.xAxis = [{
                categories: this.powergencategories
              },];
              this.chartOptions13 = JSON.parse(JSON.stringify(this.chartOptions13));
              // this.updateFlag = true;
            }

            else if (this.is_wms == 0 && this.is_emeter == 1) {
              this.chartOptions14.series = [
                //   {
                //   name: 'Power Generated(KW)',
                //   yAxis: 0,
                //   data: this.powerGraphArray
                // },

                {
                  name: 'Load Power (KW)',
                  yAxis: 0,
                  data: this.IrrGraphArray1
                },
                {
                  name: 'Solar Power (KW)',
                  yAxis: 1,
                  data: this.IrrGraphArray2
                },
                {
                  name: 'Grid Power (KW)',
                  yAxis: 2,
                  data: this.IrrGraphArray3
                },
                /* R{
                  name: 'DG Power (KW)',
                  yAxis: 2,
                  data: this.IrrGraphArray4
                },ER */
                // {
                //   name: 'SPP (%)',
                //   yAxis: 3,
                //   data: this.spp
                // },
              ];
              this.chartOptions14.xAxis = [{
                categories: this.powergencategories
              },];
              this.chartOptions14 = JSON.parse(JSON.stringify(this.chartOptions14));

              // this.updateFlag = true;
            }




            /*  this.normaluserDayGarphArray = result.resultObject;
             for (let i = 0; i < this.normaluserDayGarphArray.length; i++) {
                if (this.normaluserDayGarphArray[i].date_time) {
                  const stringToSplit = this.normaluserDayGarphArray[i].date_time;
                  const x = stringToSplit.split(' ');
                  this.categories.push(x[1]);
                  this.data.push(Number(this.normaluserDayGarphArray[i].power_generation));
                }
              }
              this.chartOptions.series = [{
                name: 'Power Generated in KW',
                data: this.data
              },];
    
              this.chartOptions.xAxis = [{
                categories: this.categories
              },];*/


          } else if (!result.status) {
            if (result.message === 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(['/login']);
            } else {
              this.toastr.info(result.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  // Dynamic monthgraph for ZE user
  public dashboardZEUserMonthGraph() {
    this.graphMonthObj = {
      month: this.pipe.transform(this.monthwmsform.controls.monthYear.value, 'MM'),
      year: this.pipe.transform(this.monthwmsform.controls.monthYear.value, 'yyyy'),
      user_id: this.login_Id,
    };
    this.dashboardService.dashboardZEUserEnergyMonthGraph(this.graphMonthObj)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        async result => {
          this.month_categories = [];
          this.month_data = [];
          this.monthPowerSumWmsUser = 0;
          this.monthDaySpcificYeildWmsUser = 0;
          this.normaluserMonthGarphArray = [];
          if (result.status) {

            this.monthPowerSumWmsUser = result.sum_power_gen.toFixed(2);
            this.monthDaySpcificYeildWmsUser = result.specific_yeild.toFixed(2);
            this.normaluserMonthGarphArray = result.resultObject;
            // tslint:disable-next-line: prefer-for-of
            for (let i = 0; i < this.normaluserMonthGarphArray.length; i++) {
              if (this.normaluserMonthGarphArray[i].date) {
                this.month_categories.push(this.normaluserMonthGarphArray[i].date);
                this.month_data.push(Number(this.normaluserMonthGarphArray[i].power_generation));
              }
            }
            // render data for chart
            this.chartOptions7.series = [{
              name: 'Energy Generated in KWh',
              data: this.month_data
            },];
            this.chartOptions7.xAxis = [{
              categories: this.month_categories
            },];
            this.chartOptions7 = JSON.parse(JSON.stringify(this.chartOptions7));
            // this.updateFlag = true;
          } else if (!result.status) {
            if (result.message === 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(['/login']);
            } else {
              this.toastr.info(result.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  // Dynamic yeargraph for ZE user
  public dashboardZEUseYearGraph() {
    this.graphYearObj = {
      year: this.pipe.transform(this.yearwmsform.controls.year.value, 'yyyy'),
      user_id: this.login_Id,
    };
    this.dashboardService.dashboardZEUserEnergyYearGraph(this.graphYearObj)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        async result => {
          this.year_Categories = [];
          this.year_Data = [];
          this.YearPowerSumWmsUser = 0;
          this.YearSpcificYeildWmsUser = 0;
          this.normaluserYearGarphArray = [];
          if (result.status) {
            this.YearPowerSumWmsUser = result.sum_power_gen.toFixed(2);
            this.YearSpcificYeildWmsUser = result.specific_yeild.toFixed(2);
            this.normaluserYearGarphArray = result.resultObject;
            // tslint:disable-next-line:prefer-for-of
            for (let i = 0; i < this.normaluserYearGarphArray.length; i++) {
              if (this.normaluserYearGarphArray[i].month) {
                this.year_Categories.push(this.normaluserYearGarphArray[i].month);
                this.year_Data.push(this.normaluserYearGarphArray[i].power_generation);
              }
            }
            // update graph Serise
            this.chartOptions2.series = [{
              name: 'Energy Generated in KWh',
              data: this.year_Data
            },];
            this.chartOptions2.xAxis = [{
              categories: this.year_Categories
            },];
            // this.updateFlag = true;
            this.chartOptions2 = JSON.parse(JSON.stringify(this.chartOptions2));
          } else if (!result.status) {
            if (result.message === 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(['/login']);
            } else {
              this.toastr.info(result.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  // Dynamic lifetime graph for ZE user
  public dashboardZEUseLifeTimeGraph() {
    this.graphLifeTimeObj = {
      start_year: '2017',
      user_id: this.login_Id,
    };
    this.dashboardService.dashboardNormalUserEnergyLifeTimeGraph(this.graphLifeTimeObj)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        async result => {
          this.Life_time_Categories = [];
          this.Life_time_Data = [];
          this.LifeTimePowerSumWmsUser = 0;
          this.normaluserLifeTimeGarphArray = [];
          if (result.status) {
            this.LifeTimePowerSumWmsUser = result.sum_power_gen.toFixed(2);
            this.normaluserLifeTimeGarphArray = result.resultObject;
            // tslint:disable-next-line:prefer-for-of
            for (let i = 0; i < this.normaluserLifeTimeGarphArray.length; i++) {
              if (this.normaluserLifeTimeGarphArray[i].year) {
                this.Life_time_Categories.push(this.normaluserLifeTimeGarphArray[i].year);
                this.Life_time_Data.push(Number(this.normaluserLifeTimeGarphArray[i].power_generation));
              }
            }
            // update graph serise
            this.chartOptions3.series = [{
              name: 'Energy Generated in KWh',
              data: this.Life_time_Data
            },];
            this.chartOptions3.xAxis = [{
              categories: this.Life_time_Categories
            },];
            this.chartOptions3 = JSON.parse(JSON.stringify(this.chartOptions3));
            // this.updateFlag = true;
          } else if (!result.status) {
            if (result.message === 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(['/login']);
            } else {
              this.toastr.info(result.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  /**-------------------ZE USER---------- */






  /**-------------------DG USER------------ */
  // Dynamic DayGraph for DG user
  public dashboardDGUserDayGraph() {
    // var pipe = new DatePipe('en-US')
    // this.myFormattedDate = pipe.transform(this.currentDate, );
    this.graphObj = {
      date: this.pipe.transform(this.dayform.controls.dayDate.value, 'dd-MM-yyyy'),
      user_id: this.login_Id,
    };
    this.dashboardService.dashboardNormalUserEnergyDayGraph(this.graphObj)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        async result => {
          this.categories = [];
          this.data = [];
          this.normaluserDayGarphArray = [];
          if (result.status) {
            this.DayPowerSumNormalUser = result.sum_power_gen.toFixed(2);
            this.DaySpcificYeildNormalUser = result.specific_yeild.toFixed(2);
            this.normaluserDayGarphArray = result.resultObject;
            // tslint:disable-next-line: prefer-for-of
            for (let i = 0; i < this.normaluserDayGarphArray.length; i++) {
              if (this.normaluserDayGarphArray[i].date_time) {
                const stringToSplit = this.normaluserDayGarphArray[i].date_time;
                const x = stringToSplit.split(' ');
                this.categories.push(x[1]);
                this.data.push(Number(this.normaluserDayGarphArray[i].power_generation));
              }
            }
            this.chartOptions.series = [{
              name: 'Power Generated in KW',
              data: this.data
            },];

            this.chartOptions.xAxis = [{
              categories: this.categories
            },];
            this.chartOptions = JSON.parse(JSON.stringify(this.chartOptions));
            // this.updateFlag = true;
          } else if (!result.status) {
            if (result.message === 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(['/login']);
            } else {
              this.toastr.info(result.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  // Dynamic monthgraph for DG user
  public dashboardDGUserMonthGraph() {
    this.graphMonthObj = {
      month: this.pipe.transform(this.monthform.controls.monthYear.value, 'MM'),
      year: this.pipe.transform(this.monthform.controls.monthYear.value, 'yyyy'),
      user_id: this.login_Id,
    };
    this.dashboardService.dashboardNormalUserEnergyMonthGraph(this.graphMonthObj)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        async result => {
          this.month_categories = [];
          this.month_data = [];
          this.monthPowerSumNormalUser = 0;
          this.normalGraphSpicificYeild = 0;
          this.normaluserMonthGarphArray = [];
          if (result.status) {

            this.monthPowerSumNormalUser = result.sum_power_gen.toFixed(2);
            this.normalGraphSpicificYeild = result.specific_yeild.toFixed(2);
            this.normaluserMonthGarphArray = result.resultObject;
            // tslint:disable-next-line: prefer-for-of
            for (let i = 0; i < this.normaluserMonthGarphArray.length; i++) {
              if (this.normaluserMonthGarphArray[i].date) {
                this.month_categories.push(this.normaluserMonthGarphArray[i].date);
                this.month_data.push(Number(this.normaluserMonthGarphArray[i].power_generation));
              }
            }
            // render data for chart
            this.chartOptions1.series = [{
              name: 'Energy Generated in KWh',
              data: this.month_data
            },];
            this.chartOptions1.xAxis = [{
              categories: this.month_categories
            },];
            this.chartOptions1 = JSON.parse(JSON.stringify(this.chartOptions1));

            // this.updateFlag = true;
          } else if (!result.status) {
            if (result.message === 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(['/login']);
            } else {
              this.toastr.info(result.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  // Dynamic yeargraph for DG user
  public dashboardDGUseYearGraph() {
    this.graphYearObj = {
      year: this.pipe.transform(this.yearform.controls.year.value, 'yyyy'),
      user_id: this.login_Id,
    };
    this.dashboardService.dashboardNormalUserEnergyYearGraph(this.graphYearObj)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        async result => {
          this.year_Categories = [];
          this.year_Data = [];
          this.yearPowerSumNormalUser = 0;
          this.yearSpicificYeildNormalUser = 0;
          this.normaluserYearGarphArray = [];
          if (result.status) {
            this.yearPowerSumNormalUser = result.sum_power_gen.toFixed(2);
            this.yearSpicificYeildNormalUser = result.specific_yeild.toFixed(2);
            this.normaluserYearGarphArray = result.resultObject;
            // tslint:disable-next-line:prefer-for-of
            for (let i = 0; i < this.normaluserYearGarphArray.length; i++) {
              if (this.normaluserYearGarphArray[i].month) {
                this.year_Categories.push(this.normaluserYearGarphArray[i].month);
                this.year_Data.push(this.normaluserYearGarphArray[i].power_generation);
              }
            }
            // update graph Serise
            this.chartOptions2.series = [{
              name: 'Energy Generated in KWh',
              data: this.year_Data
            },];
            this.chartOptions2.xAxis = [{
              categories: this.year_Categories
            },];
            // this.updateFlag = true;
            this.chartOptions2 = JSON.parse(JSON.stringify(this.chartOptions2));

          } else if (!result.status) {
            if (result.message === 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(['/login']);
            } else {
              this.toastr.info(result.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  // Dynamic lifetime graph for DG user
  public dashboardDGUseLifeTimeGraph() {
    this.graphLifeTimeObj = {
      start_year: '2017',
      user_id: this.login_Id,
    };
    this.dashboardService.dashboardNormalUserEnergyLifeTimeGraph(this.graphLifeTimeObj)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        async result => {
          this.Life_time_Categories = [];
          this.Life_time_Data = [];
          this.lifeTimePowerSumNormalUser = 0;
          this.normaluserLifeTimeGarphArray = [];
          if (result.status) {
            this.lifeTimePowerSumNormalUser = result.sum_power_gen.toFixed(2);
            this.normaluserLifeTimeGarphArray = result.resultObject;
            // tslint:disable-next-line:prefer-for-of
            for (let i = 0; i < this.normaluserLifeTimeGarphArray.length; i++) {
              if (this.normaluserLifeTimeGarphArray[i].year) {
                this.Life_time_Categories.push(this.normaluserLifeTimeGarphArray[i].year);
                this.Life_time_Data.push(Number(this.normaluserLifeTimeGarphArray[i].power_generation));
              }
            }
            // update graph serise
            this.chartOptions3.series = [{
              name: 'Energy Generated in KWh',
              data: this.Life_time_Data
            },];
            this.chartOptions3.xAxis = [{
              categories: this.Life_time_Categories
            },];
            // this.updateFlag = true;
            this.chartOptions3 = JSON.parse(JSON.stringify(this.chartOptions3));
          } else if (!result.status) {
            if (result.message === 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(['/login']);
            } else {
              this.toastr.info(result.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  /**-------------------DG USER---------- */


  // Dynamic monthgraph for wms user
  public dashboardWmsUserMonthGraph() {
    this.graphMonthObj = {
      month: this.pipe.transform(this.monthwmsform.controls.monthYear.value, 'MM'),
      year: this.pipe.transform(this.monthwmsform.controls.monthYear.value, 'yyyy'),
      user_id: this.login_Id,
    };
    this.dashboardService.dashboardWmsUserEnergyMonthGraph(this.graphMonthObj).subscribe(
      async result => {
        this.wmsmonth_categories = [];
        this.wmsmonth_data = [];
        this.monthPowerSumWmsUser = 0;
        this.monthDaySpcificYeildWmsUser = 0;
        if (result.status) {
          this.monthPowerSumWmsUser = result.sum_power_gen.toFixed(2);
          this.monthDaySpcificYeildWmsUser = result.specific_yeild.toFixed(2);
          const graphDetails = result.resultObject;
          // tslint:disable-next-line:prefer-for-of
          for (let i = 0; i < graphDetails.length; i++) {
            if (graphDetails[i].date) {
              this.wmsmonth_categories.push(graphDetails[i].date);
              this.wmsmonth_data.push(Number(graphDetails[i].power_generation));
            }
          }
          this.chartOptions7.series = [{
            name: 'Energy Generated in KWh',
            data: this.wmsmonth_data
          },];
          this.chartOptions7.xAxis = [{
            categories: this.wmsmonth_categories
          },];
          this.chartOptions7 = JSON.parse(JSON.stringify(this.chartOptions7));
          // this.updateFlag = true;
        }
        if (result.message === 'Unauthorised or Login Time-out') {
          this.router.navigate(['/login']);
        } else if (!result.status) {
        }
      },
      err => {
        return console.error(err);
      }
    );
  }

  // Dynamic DayGraph AmbientAndIrradition for wms user
  public wmsUseAmbientAndIrraditionDayGraph() {
    this.graphObj = {
      toDate: this.pipe.transform(this.AmbientDayGraphform.controls.date.value, 'dd-MM-yyyy'),
      fromDate: this.pipe.transform(this.AmbientDayGraphform.controls.date.value, 'dd-MM-yyyy'),
      user_id: this.login_Id,
    };
    this.dashboardService.dashboardWmsUserAmbientAndIrraditionDayGraph(this.graphObj).subscribe(
      async result => {
        this.Ambientcategories = [];
        this.IrraditionGraphArray = [];
        this.AmbientGraphArray = [];
        if (result.status) {
          const tempGraphArray = result.resultObject.ambient_temp;
          const IrrGraphArray = result.resultObject.IrrData;
          // tslint:disable-next-line:prefer-for-of
          for (let i = 0; i < IrrGraphArray.length; i++) {
            if (IrrGraphArray[i].date_time) {
              const stringToSplit = IrrGraphArray[i].date_time;
              const x = stringToSplit.split(' ');
              this.Ambientcategories.push(x[1]);
              this.IrraditionGraphArray.push(Number(IrrGraphArray[i].value));
            }
          }
          // tslint:disable-next-line:prefer-for-of
          for (let i = 0; i < tempGraphArray.length; i++) {
            this.AmbientGraphArray.push(Number(tempGraphArray[i].value));
          }
          // update graph serise
          this.chartOptions4.series = [{
            name: 'Ambient Temp(Degrees)',
            yAxis: 0,
            data: this.AmbientGraphArray
          },
          {
            name: 'Irradiance(w/m^2)',
            yAxis: 1,
            data: this.IrraditionGraphArray
          },];
          this.chartOptions4.xAxis = [{
            categories: this.Ambientcategories
          },];
          this.updateFlag1 = true;
        }
        if (result.message === 'Unauthorised or Login Time-out') {
          this.router.navigate(['/login']);

        } else if (!result.status) {

        }
      },
      err => {
        return console.error(err);
      }
    );
  }

  // Dynamic DayGraph  PowerAndIrradition for wms user
  public dashboardWmsUserPowerAndIrraditionDayGraph() {

    this.graphObj = {
      date: this.pipe.transform(this.daywmsform.controls.dayDate.value, 'dd-MM-yyyy'),
      user_id: this.login_Id,
    };

    this.dashboardService.dashboardNormalUserEnergyDayGraph(this.graphObj)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        async result => {
          this.powergencategories = [];
          this.IrrGraphArray = [];
          this.powerGraphArray = [];
          this.DayPowerSumWmsUser = 0;
          this.DaySpcificYeildWmsUser = 0;
          this.DayInsolation = 0;
          this.DayPR = 0;
          if (result.status) {
            this.DayPowerSumWmsUser = result.sum_power_gen.toFixed(2);
            this.DaySpcificYeildWmsUser = result.specific_yeild.toFixed(2);
            this.DayInsolation = result.insolation;
            this.DayPR = result.pr;
            const powerGraphArray = result.resultObject.power_generation;
            const IrrGraphArray = result.resultObject.IrrData;

            // tslint:disable-next-line: prefer-for-of
            for (let i = 0; i < IrrGraphArray.length; i++) {
              if (IrrGraphArray[i].date_time) {
                this.IrrGraphArray.push(Number(IrrGraphArray[i].value));
              }
            }
            // tslint:disable-next-line:prefer-for-of
            for (let i = 0; i < powerGraphArray.length; i++) {
              this.powerGraphArray.push(Number(powerGraphArray[i].power_generation));
              const stringToSplit = powerGraphArray[i].date_time;
              const x = stringToSplit.split(' ');
              this.powergencategories.push(x[1]);
            }
            // update graph serise

            this.chartOptions5.series = [{
              name: 'Power Genrated(KW)',
              yAxis: 0,
              data: this.powerGraphArray
            },
            {
              name: 'Irradiance(w/m^2)',
              yAxis: 1,
              data: this.IrrGraphArray
            },];

            this.chartOptions5.xAxis = [{
              categories: this.powergencategories
            },];
            // this.updateFlag = true;
            this.chartOptions5 = JSON.parse(JSON.stringify(this.chartOptions5));
          } else if (!result.status) {
            if (result.message === 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(['/login']);
            } else {
              this.toastr.info(result.message);
            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  // Dynamic lifetime graph for wms user
  public dashboarWmsUseLifeTimeGraph() {
    this.graphLifeTimeObj = {
      start_year: '2017',
      user_id: this.login_Id,
    };
    this.dashboardService.dashboardNormalUserEnergyLifeTimeGraph(this.graphLifeTimeObj)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        async result => {
          this.WmsLife_time_Categories = [];
          this.WmsLife_time_Data = [];
          this.normaluserLifeTimeGarphArray = [];
          this.LifeTimePowerSumWmsUser = 0;
          if (result.status) {
            this.LifeTimePowerSumWmsUser = result.sum_power_gen.toFixed(2);
            const LifeTimeGarphArray = result.resultObject;
            // tslint:disable-next-line:prefer-for-of
            for (let i = 0; i < LifeTimeGarphArray.length; i++) {
              if (LifeTimeGarphArray[i].year) {
                this.WmsLife_time_Categories.push(LifeTimeGarphArray[i].year);
                this.WmsLife_time_Data.push(Number(LifeTimeGarphArray[i].power_generation));
              }
            }
            // update graph serise
            this.chartOptions6.series = [{
              name: 'Energy Generated in KWh',
              data: this.WmsLife_time_Data
            },];
            this.chartOptions6.xAxis = [{
              categories: this.WmsLife_time_Categories
            },];
            this.chartOptions6 = JSON.parse(JSON.stringify(this.chartOptions6));
            // this.updateFlag = true;
          } else if (!result.status) {
            if (result.message === 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(['/login']);
            } else {
              this.toastr.info(result.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  // Dynamic yeargraph for wms user
  public dashboardWmsUseYearGraph() {
    this.graphYearObj = {
      year: this.pipe.transform(this.yearwmsform.controls.year.value, 'yyyy'),
      user_id: this.login_Id,
    };
    this.dashboardService.dashboardNormalUserEnergyYearGraph(this.graphYearObj)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        async result => {
          this.YearPowerSumWmsUser = 0;
          this.YearSpcificYeildWmsUser = 0;
          this.wmsYear_Categories = [];
          this.wmsyear_Data = [];
          this.normaluserYearGarphArray = [];
          if (result.status) {
            this.YearPowerSumWmsUser = result.sum_power_gen.toFixed(2);
            this.YearSpcificYeildWmsUser = result.specific_yeild.toFixed(2);
            const YearArray = result.resultObject;
            // tslint:disable-next-line:prefer-for-of
            for (let i = 0; i < YearArray.length; i++) {
              if (YearArray[i].month) {
                this.wmsYear_Categories.push(YearArray[i].month);
                this.wmsyear_Data.push(Number(YearArray[i].power_generation));
              }
            }
            // update graph Serise
            this.chartOptions8.series = [{
              name: 'Energy Generated in KWh',
              data: this.wmsyear_Data
            },];
            this.chartOptions8.xAxis = [{
              categories: this.wmsYear_Categories
            },];
            // this.updateFlag = true;
            this.chartOptions8 = JSON.parse(JSON.stringify(this.chartOptions8));
          } else if (!result.status) {
            if (result.message === 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(['/login']);
            } else {
              this.toastr.info(result.message);
            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  // device status for normal user old
  public getDeviceStatus() {
    this.ngxUiLoaderService.startBackgroundLoader(this.loaders[16].loaderId);
    this.dashboardService.getDeviceStatus()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        async result => {
          this.deviceStatus = [];
          if (result.status) {
            this.deviceStatus = result.resultObject;
            this.ngxUiLoaderService.stopBackgroundLoader(this.loaders[16].loaderId);
          } else if (!result.status) {
            if (result.message === 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(['/login']);
            } else {
              this.toastr.info(result.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  out() {
    this.flag = false;
    //alert("out")
  }
  public getDeviceErrorStatus() {
    this.flag = false;
    this.error = "";
    this.title = "";
    this.dev_status = "";
    this.deviceRequestObject = {
      serial_no: this.serial_no,
    }
    this.dashboardService.getDeviceErrorStatus(this.deviceRequestObject)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        async result => {
          this.deviceErrorStatus = [];
          if (result.status) {
            // this.eventtype='mouseenter'
            // this.error="";
            // this.title="";
            // this.dev_status="";
            this.deviceErrorStatus = result.resultObject;
            this.title = result.resultObject[0].title;
            this.error = result.resultObject[0].error;
            this.dev_status = result.resultObject[0].dev_status;

            this.flag = true;

            //  this.flag=false;
          } else if (!result.status) {
            if (result.message === 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(['/login']);
            } else {
              this.toastr.info(result.message);
            }
          }

        },

        err => {
          return console.error(err);
        }

      );
    this.flag = false;
  }

  public getMeterErrorStatus() {
    this.flag = false;
    this.error = "";
    this.title = "";
    this.dev_status = "";
    this.invRequestObject = {
      serial_no: this.serial_no_inv,
      sub_device_id: this.sub_device_id_inv,
    }

    this.dashboardService.getInverterErrorStatus(this.invRequestObject)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        async result => {
          this.invErrorStatus = [];
          if (result.status) {
            // this.eventtype='mouseenter'
            // this.error="";
            // this.title="";
            this.invErrorStatus = result.resultObject;
            this.error = result.resultObject[0].error;
            this.title = result.resultObject[0].title;
            this.dev_status = result.resultObject[0].dev_status;
            this.flag = true;
          } else if (!result.status) {
            if (result.message === 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(['/login']);
            } else {
              this.toastr.info(result.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
    this.flag = false;
  }
  // device status for ZE user
  public getZEDeviceStatus() {
    this.ngxUiLoaderService.startBackgroundLoader(this.loaders[13].loaderId);
    this.dashboardService.getZEDeviceStatus()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        async result => {
          this.deviceStatus = [];
          if (result.status) {
            this.deviceStatus = result.resultObject;
            this.serial_no = result.resultObject[0].serial_no;
            this.ngxUiLoaderService.stopBackgroundLoader(this.loaders[13].loaderId);
            //   this.getDeviceErrorStatus();
          } else if (!result.status) {
            if (result.message === 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(['/login']);
            } else {
              this.toastr.info(result.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  // device status for normal user old
  public getInverterStatus() {

    this.ngxUiLoaderService.startBackgroundLoader(this.loaders[17].loaderId);

    this.dashboardService.getInverterStatus()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        async result => {
          if (result.status) {
            this.inverterStatus = result.resultObject;
            this.serial_no = result.resultObject[0].serial_no;
            this.sub_device_id = result.resultObject[0].sub_device_id;
            this.ngxUiLoaderService.stopBackgroundLoader(this.loaders[17].loaderId);
            //   this.getInverterErrorStatus();
          } else if (!result.status) {
            if (result.message === 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(['/login']);
            } else {
              this.toastr.info(result.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  // device status for normal user new
  // public getInverterStatus() {
  //   this.invRequestObject={
  //     serial_no:this.serial_no
  //    }
  //   this.dashboardService.getInverterStatusNormal(this.invRequestObject)
  //     .pipe(takeUntil(this.ResponseVerifiedNormalUserInverterStatus$))
  //     .subscribe(
  //       async result => {
  //         if (result.status) {
  //           this.inverterStatus = result.resultObject;
  //         } else if (!result.status) {
  //           if (result.message === 'Unauthorised or Login Time-out') {
  //             this.toastr.info(result.message);
  //             this.router.navigate(['/login']);
  //           } else {
  //             this.toastr.info(result.message);
  //           }
  //         }
  //       },
  //       err => {
  //         return console.error(err);
  //       }
  //     );
  // }
  // device status for normal user
  public getMeterStatus() {
    this.ngxUiLoaderService.startBackgroundLoader(this.loaders[15].loaderId);
    this.dashboardService.getMeterStatus()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        async result => {
          if (result.status) {
            this.meterStatus = result.resultObject;
            this.serial_no = result.resultObject[0].serial_no;
            this.sub_device_id = result.resultObject[0].sub_device_id;
            this.ngxUiLoaderService.stopBackgroundLoader(this.loaders[15].loaderId);
          } else if (!result.status) {
            if (result.message === 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(['/login']);
            } else {
              this.toastr.info(result.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }


  //dg status
  public getDgStatus() {
    this.ngxUiLoaderService.startBackgroundLoader(this.loaders[16].loaderId);
    this.dashboardService.getDgStatus()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        async result => {
          if (result.status) {
            this.dgstatus = result.resultObject;
            // console.log(this.dgstatus);
            // this.serial_no = result.resultObject[0].serial_no;
            // this.sub_device_id = result.resultObject[0].sub_device_id;
            this.ngxUiLoaderService.stopBackgroundLoader(this.loaders[16].loaderId);
          } else if (!result.status) {
            if (result.message === 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(['/login']);
            } else {
              this.toastr.info(result.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  // Grid Status
  public getGridStatus() {
    this.ngxUiLoaderService.startBackgroundLoader(this.loaders[17].loaderId);
    this.dashboardService.getGridStatus()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        async result => {
          if (result.status) {
            this.gridstatus = result.resultObject;
            // console.log(this.dgstatus);
            // this.serial_no = result.resultObject[0].serial_no;
            // this.sub_device_id = result.resultObject[0].sub_device_id;
            this.ngxUiLoaderService.stopBackgroundLoader(this.loaders[17].loaderId);
          } else if (!result.status) {
            if (result.message === 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(['/login']);
            } else {
              this.toastr.info(result.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }


  public getDeviceNewStatus() {
    // this.ngxUiLoaderService.startBackgroundLoader(this.loaders[21].loaderId);
    this.dashboardService.getDeviceNewStatus()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        async result => {
          if (result.status) {
            //console.log(result.resultObject.length);
            if (result.resultObject.length > 0) {
              this.meterStatusD = result.resultObject;
              this.serial_noD = result.resultObject[0].serial_no;
              this.sub_device_idD = result.resultObject[0].sub_device_id;
              //  this.ngxUiLoaderService.stopBackgroundLoader(this.loaders[21].loaderId);
            }
          } else if (!result.status) {
            if (result.message === 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(['/login']);
            } else {
              this.toastr.info(result.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  // Normal User Dashboard inverter details
  public getInverterDetails() {
    this.dashboardService.getInverterDetails()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        async result => {
          if (result.status) {
            this.inverterDetails = result.resultObject;
          } else if (!result.status) {
            if (result.message === 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(['/login']);
            } else {
              this.toastr.info(result.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  // device status for ZE user
  public getZEInverterStatus() {
    this.ngxUiLoaderService.startBackgroundLoader(this.loaders[14].loaderId);
    this.dashboardService.getZEInverterStatus()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        async result => {
          if (result.status) {
            this.inverterStatus = result.resultObject;
            this.serial_no = result.resultObject[0].serial_no;
            this.sub_device_id = result.resultObject[0].sub_device_id;
            this.ngxUiLoaderService.stopBackgroundLoader(this.loaders[14].loaderId);
            //    this.getInverterErrorStatus();
          } else if (!result.status) {
            if (result.message === 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(['/login']);
            } else {
              this.toastr.info(result.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  // ZE User Dashboard inverter details
  public getZEInverterDetails() {
    this.dashboardService.getZEInverterDetails()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        async result => {
          if (result.status) {
            this.inverterDetails = result.resultObject;
          } else if (!result.status) {
            if (result.message === 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(['/login']);
            } else {
              this.toastr.info(result.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  // device status for DG user
  public getDGInverterStatus() {
    this.dashboardService.getDGInverterStatus()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        async result => {
          if (result.status) {
            this.inverterStatus = result.resultObject;
          } else if (!result.status) {
            if (result.message === 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(['/login']);
            } else {
              this.toastr.info(result.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  // DG User Dashboard inverter details
  public getDGInverterDetails() {
    this.dashboardService.getDGInverterDetails()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        async result => {
          if (result.status) {
            this.inverterDetails = result.resultObject;
          } else if (!result.status) {
            if (result.message === 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(['/login']);
            } else {
              this.toastr.info(result.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  // wms User Dashboard inverter details
  getWmsInverterDetails() {
    this.dashboardService.getWmsInverterDetails()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        async result => {
          if (result.status) {
            this.wmsInverterDetails = result.resultObject;
          } else if (!result.status) {
            if (result.message === 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(['/login']);
            } else {
              this.toastr.info(result.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  // DAY GRAPH normal user this call custom datepiker component
  onDayChange() {
    this.currentDate = this.dayform.value.dayDate;
    this.dashboardNormalUserDayGraph();
  }

  // Year GRAPH normal user this call custom datepiker component
  chosenYearHandler() {
    this.currentDate = this.yearform.value.year;
    this.dashboardNormalUseYearGraph();
    //   container.setViewMode('month');
  }
  // Year GRAPH normal user this call custom datepiker component
  chosenYearHandlerZE() {
    this.currentDate = this.yearform.value.year;
    this.dashboardZEUseYearGraph();
    //   container.setViewMode('month');
  }
  // Month GRAPH normal user this call custom datepiker component
  chosenMonth() {
    this.currentDate = this.monthform.value.monthYear;
    this.dashboardNormalUserMonthGraph();
  }

  // Year GRAPH wms user
  chosenYearHandlerWms() {
    this.dashboardWmsUseYearGraph();
  }

  // Month GRAPH wms user
  chosenMonthWms() {
    this.dashboardWmsUserMonthGraph();
  }

  // Month GRAPH wms user
  chosenMonthZE() {
    this.dashboardZEUserMonthGraph();
  }
  // device status for wms user
  public getWmsDeviceStatus() {

    this.ngxUiLoaderService.startBackgroundLoader(this.loaders[18].loaderId);

    this.dashboardService.getWmsDeviceStatus()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        async result => {
          this.deviceStatus = [];
          if (result.status) {
            this.deviceStatus = result.resultObject;
            this.ngxUiLoaderService.stopBackgroundLoader(this.loaders[18].loaderId);
            // this.serial_no = result.resultObject[0].serial_no;
            //    this.getDeviceErrorStatus();
          } else if (!result.status) {
            if (result.message === 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(['/login']);
            } else {
              this.toastr.info(result.message);
            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  // inverter status for wms user
  getWmsInverterStatus() {
    this.ngxUiLoaderService.startBackgroundLoader(this.loaders[19].loaderId);
    this.dashboardService.getWmsInverterStatus()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        async result => {
          if (result.status) {
            this.inverterStatus = result.resultObject;
            this.serial_no = result.resultObject[0].serial_no;
            this.sub_device_id = result.resultObject[0].sub_device_id;
            this.ngxUiLoaderService.stopBackgroundLoader(this.loaders[19].loaderId);
            //this.serial_no = result.resultObject[0].serial_no;
            //   this.sub_device_id = result.resultObject[0].sub_device_id;
            //  this.getInverterErrorStatus();

          } else if (!result.status) {
            if (result.message === 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(['/login']);
            } else {
              this.toastr.info(result.message);
            }

          }
        },
        err => {
          return console.error(err);
        }
      );



  }
  getId(value, event) {
    this.flag == false;
    this.serial_no = value;
    this.eventtype = event.type;
    this.getDeviceErrorStatus();

  }
  getMeterId(value, value1, event) {
    this.flag == false;
    this.serial_no_inv = value;
    this.sub_device_id_inv = value1;
    this.eventtype = event.type
    //    this.getDeviceErrorStatus();

    this.getMeterErrorStatus();
  }


  // view portal
  viewPortalWmsUser(frm) {
    const loginObj = {
      user_id: frm,
      isview: true
    };
    this.dashboardService.loginViewPortal(loginObj)
      .subscribe(
        data => {
          if (data.status) {
            localStorage.clear();
            this.toastr.success(data.message);
            this.token = data.resultObject.token;
            this.role = data.resultObject.role;
            this.id = data.resultObject.id;
            this.name = data.resultObject.name;
            this.login_id = data.resultObject.login_id;
            this.logo = data.resultObject.logo;
            this.company_name = data.resultObject.company_name;
            this.epc_id = data.resultObject.epc_id;
            this.isview = data.isview;
            this.admin_id = data.resultObject.admin_id;
            this.SadminAccess1 = data.resultObject.SadminAccess;
            this.is_emeter = data.resultObject.is_emeter;
            this.is_wms = data.resultObject.is_wms;

            localStorage.setItem('slave_admin_id', this.slave_admin_id);
            localStorage.setItem('loginToken', this.token);
            localStorage.setItem('role', this.role);
            localStorage.setItem('name', this.name);
            localStorage.setItem('id', this.id);
            localStorage.setItem('login_id', this.login_id);
            localStorage.setItem('logo', this.logo);
            localStorage.setItem('company_name', this.company_name);
            localStorage.setItem('epc_id', this.epc_id);
            localStorage.setItem('isview', this.isview);
            localStorage.setItem('admin_id', this.admin_id);
            localStorage.setItem('through', this.through);
            localStorage.setItem('SadminAccess', JSON.stringify(this.SadminAccess1) || '[]');
            localStorage.setItem('is_emeter', this.is_emeter);
            localStorage.setItem('is_wms', this.is_wms);
            window.location.reload();
          } else if (!data.status) {
            if (data.message === 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(['/login']);
            } else {
              this.toastr.info(data.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  // viewPortalWmsUserEpc(frm) {
  //   const loginObj = {
  //     user_id: frm,
  //     isview: true
  //   };
  //   this.dashboardService.loginViewPortalEpc(loginObj)
  //     .subscribe(
  //       data => {
  //         if (data.status) {
  //           localStorage.clear();
  //           this.toastr.success(data.message);
  //           this.token = data.resultObject.token;
  //           this.role = data.resultObject.role;
  //           this.id = data.resultObject.id;
  //           this.name = data.resultObject.name;
  //           this.login_id = data.resultObject.login_id;
  //           this.logo = data.resultObject.logo;
  //           this.company_name = data.resultObject.company_name;
  //           this.epc_id = data.resultObject.epc_id;
  //           this.isview = data.isview;
  //           this.admin_id = data.resultObject.admin_id;
  //           this.SadminAccess1 = data.resultObject.SadminAccess;
  //           this.is_emeter = data.resultObject.is_emeter;
  //           this.is_wms = data.resultObject.is_wms;

  //           localStorage.setItem('slave_admin_id', this.slave_admin_id);
  //           localStorage.setItem('loginToken', this.token);
  //           localStorage.setItem('role', this.role);
  //           localStorage.setItem('name', this.name);
  //           localStorage.setItem('id', this.id);
  //           localStorage.setItem('login_id', this.login_id);
  //           localStorage.setItem('logo', this.logo);
  //           localStorage.setItem('company_name', this.company_name);
  //           localStorage.setItem('epc_id', this.epc_id);
  //           localStorage.setItem('isview', this.isview);
  //           localStorage.setItem('admin_id', this.admin_id);
  //           localStorage.setItem('through', this.through);
  //           localStorage.setItem('SadminAccess', JSON.stringify(this.SadminAccess1) || '[]');
  //           localStorage.setItem('is_emeter', this.is_emeter);
  //           localStorage.setItem('is_wms', this.is_wms);
  //           window.location.reload();
  //         } else if (!data.status) {
  //           if (data.message === 'Unauthorised or Login Time-out') {
  //             this.toastr.info(data.message);
  //             this.router.navigate(['/login']);
  //           } else {
  //             this.toastr.info(data.message);
  //           }
  //         }
  //       },
  //       err => {
  //         return console.error(err);
  //       }
  //     );
  // }
  ngOnDestroy() {
    this.bnIdle.stopTimer();
    this.destroy$.next();
    this.destroy$.complete();
  }

}
